/**
 * ZaunIdeal — Doppelstabmatten Konfigurator
 * Vanilla JS, no framework. Reads boot JSON from #hk-boot.
 */
(function () {
  'use strict';

  /* ── Boot data (#hk-boot must exist before init runs) ─────── */
  var boot = {};
  var bootAssets = {};

  function readBoot() {
    var el = document.getElementById('hk-boot');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function readVariantSkuMap() {
    var el = document.getElementById('hk-variant-map');
    if (!el || !el.textContent) return {};
    try {
      var o = JSON.parse(el.textContent.trim());
      return typeof o === 'object' && o !== null && !Array.isArray(o) ? o : {};
    } catch (e) {
      return {};
    }
  }

  function lookupManualVariantMap(skuList) {
    var raw = readVariantSkuMap();
    if (!raw || typeof raw !== 'object') return null;
    var normMap = {};
    Object.keys(raw).forEach(function (k) {
      var nk = normalizeCartSku(k);
      if (nk) normMap[nk] = raw[k];
    });
    for (var i = 0; i < skuList.length; i++) {
      var want = normalizeCartSku(skuList[i]);
      if (!want) continue;
      if (normMap[want] == null || normMap[want] === '') continue;
      var id = Number(normMap[want]);
      return isNaN(id) ? normMap[want] : id;
    }
    return null;
  }

  var DATA = {
    HEIGHTS: [
      { value: 800  }, { value: 1000 }, { value: 1200 }, { value: 1400 },
      { value: 1600 }, { value: 1800 }, { value: 2000 }, { value: 2200 },
    ],
    WIRES: [
      { value: '6/5/6', label: '6 / 5 / 6 mm', desc: 'Wirtschaftlich, leicht.',            sku: '656' },
      { value: '8/6/8', label: '8 / 6 / 8 mm', desc: 'Standard — robust, langlebig.',      sku: '868' },
    ],
    COLORS: [
      { ral: 'RAL 6005',       name: 'grün',         hex: '#114232', light: false, skuColor: '6005' },
      { ral: 'RAL 7016',       name: 'anthrazit',    hex: '#383E42', light: false, skuColor: '7016' },
      { ral: 'feuerverzinkt',  name: 'Feuerverzinkt',hex: '#B0BEC5', light: true,  skuColor: '7016' },
    ],

    // ── Real panel prices per 2500mm panel (from Shopify catalog) ───────────
    // Source: 2d-paneelzaune-251-cm-6x5x6 and 2d-paneelzaune-250-cm-8x6x8
    // fence_height (mm) → price per panel (EUR)
    PANEL_PRICES: {
      '6/5/6': { 800: 44.71, 1000: 52.84, 1200: 60.93, 1400: 69.05, 1600: 77.14, 1800: 85.26, 2000: 93.38, 2200: 101.50 },
      '8/6/8': { 800: 60.81, 1000: 72.05, 1200: 83.27, 1400: 94.52, 1600: 105.73, 1800: 116.98, 2000: 128.19, 2200: 139.40 },
    },

    // ── Real post prices by fence height (auto-selects appropriate post length) ─
    // Standard: post height = fence_height + 700mm burial depth
    // Source: zaunpfosten-fur-doppelstabmattenzaun-40x60x2-mm
    // Must match POST_SKUS: each fence height maps to a post SKU; base € = that variant in Shopify.
    POST_BASE_PRICES: {
      800: 36.44,   // post-h130
      1000: 39.72,  // post-h160
      1200: 43.29,  // post-h180
      1400: 45.22,  // post-h200
      1600: 45.22,  // post-h220 (Zaun 1600 mm)
      1800: 50.58,  // post-h240
      2000: 50.58,  // post-h240 (gleiche Variante wie 1800)
      2200: 50.58,  // post-h240
    },

    // Post SKUs for konfigurator-direk product (used for cart)
    POST_SKUS: {
      800:  'post-h130', 1000: 'post-h160', 1200: 'post-h180',
      1400: 'post-h200', 1600: 'post-h220', 1800: 'post-h240',
      2000: 'post-h240', 2200: 'post-h240',
    },

    POSTS: [
      {
        id: 'abdeck',
        label: 'Mit Abdeckleiste',
        desc: 'Zaunpfosten mit Abdeckleiste — wie im Doppelstab-Konfigurator.',
        surcharge: 0,
        surchargeCartSku: null,
        surchargeCartSkus: null,
      },
    ],
    SHOW_GATE_SECTION: false,
    MONTAGE_PANEL_EUR: 100,
    MONTAGE_CART_SKUS: ['doppelstab-montage-pro-panel', 'montage-pro-panel'],
    MOUNTS: [
      { id: 'aufduebeln',    label: 'Zum Aufdübeln',      desc: 'Auf Beton- oder Steinfläche. Schnellste Variante.', surcharge: 0,  mountCartSku: null },
      { id: 'einbetonieren', label: 'Zum Einbetonieren',  desc: 'Pfosten 60–80 cm tief in Fundament. Beste Stabilität.', surcharge: 12, mountCartSku: 'montage-aufschlag-einbetonieren-m', mountCartSkus: ['montage-aufschlag-einbetonieren-m', 'montage-einbetonieren-m', 'aufschlag-einbetonieren'], matchTitleHints: ['einbeton', 'aufschlag', 'fundament'] },
      { id: 'einschlagen',   label: 'Einschlaghülsen',    desc: 'Erdspieße — werkzeugarme Montage auf Boden.', surcharge: -8, mountCartSku: null },
    ],
    GATES: [
      { id: 'none',   label: 'Kein Tor',           price: 0,    sku: null,         gateSkus: [] },
      { id: 'single', label: 'Gehtür 100 cm',      price: 389,  sku: 'door-95x120', gateSkus: ['door-95x120', 'gehtuer-100', 'door-100'], titleHints: ['gehtür', 'gehtuer', '100', '95x120', '1200'] },
      { id: 'double', label: 'Doppeltor 300 cm',   price: 849,  sku: 'door-95x160', gateSkus: ['door-95x160', 'doppeltor-300', 'doppeltor-300cm', 'door-double-300'], titleHints: ['doppel', 'doppeltor', '300', '95x160', '1600'] },
      {
        id: 'both',
        label: 'Gehtür + Doppeltor',
        price: 1189,
        sku: null,
        gateSkus: [],
        gateLines: [
          { typ: 'Gehtür 100 cm', qty: 1, gateSkus: ['door-95x120', 'gehtuer-100', 'door-100'], titleHints: ['gehtür', 'gehtuer', '100', '95x120'] },
          { typ: 'Doppeltor 300 cm', qty: 1, gateSkus: ['door-95x160', 'doppeltor-300', 'doppeltor-300cm', 'door-double-300'], titleHints: ['doppel', 'doppeltor', '300', '95x160'] },
        ],
      },
    ],
    EXTRAS: [
      {
        id: 'klemmen',
        label: 'Universalklemmen-Set',
        desc: '12er-Set, witterungsbeständig.',
        price: 18,
        perPost: false,
        perMeter: false,
        requiresGate: false,
        cartHandle: null,
        cartSku: 'universalklemmen-set',
        cartSkus: ['universalklemmen-set', 'klemmen-set', 'universal-klemmen', 'universalklemmen'],
        matchTitleHints: ['klemm', 'universal', 'set'],
      },
      {
        id: 'abdeck',
        label: 'Pfostenabdeckkappen',
        desc: 'Aluminium, pulverbeschichtet.',
        price: 4.90,
        perPost: true,
        perMeter: false,
        requiresGate: false,
        cartHandle: null,
        cartSku: 'pfostenabdeckkappe',
        cartSkus: ['pfostenabdeckkappe', 'abdeckkappe', 'pfosten-abdeckkappe'],
        matchTitleHints: ['abdeck', 'kappe', 'pfosten'],
      },
      {
        id: 'torgriff',
        label: 'Premium Torgriff',
        desc: 'Edelstahl, gebürstet.',
        price: 89,
        perPost: false,
        perMeter: false,
        requiresGate: true,
        cartHandle: null,
        cartSku: 'premium-torgriff',
        cartSkus: ['premium-torgriff', 'torgriff-premium', 'torgriff'],
        matchTitleHints: ['torgriff', 'griff', 'premium', 'türgriff'],
      },
    ],

    // Shopify product handles used for cart (storefront API lookup)
    CART_HANDLES: {
      panel: 'konfigurator-panel',
      post:  'konfigurator-direk',
      gate:  'konfigurator-kapi',
      extras: 'konfigurator-zubehoer',
    },
    CART_ADD_ZUBEHOER: false,
  };

  function applyBootCartHandles(b) {
    if (!b || !b.cartHandles) return;
    var ch = b.cartHandles;
    if (typeof ch === 'string') {
      try { ch = JSON.parse(ch); } catch (e2) { return; }
    }
    if (!ch || typeof ch !== 'object') return;
    if (ch.panel) DATA.CART_HANDLES.panel = String(ch.panel).trim();
    if (ch.post) DATA.CART_HANDLES.post = String(ch.post).trim();
    if (ch.gate) DATA.CART_HANDLES.gate = String(ch.gate).trim();
    if (ch.extras) DATA.CART_HANDLES.extras = String(ch.extras).trim();
  }

  /* ── State ───────────────────────────────────────────────── */
  var SECTION_IDS = ['length', 'height', 'wire', 'color', 'post', 'mount', 'mitmontage'];
  var STORAGE_KEY = 'hk_konfigurator_state_v2';

  var state = loadState();
  var openSection = state._open || 'length';
  var doneSections = {};
  var cartBusy = false;

  /* Live storefront unit prices (€) for panel/post variants — keeps Gesamtpreis aligned with Warenkorb */
  var liveShopify = {
    panelEuro: null,
    postEuro: null,
    panelSku: '',
    postSku: '',
    failedKey: null,
  };
  var _variantEuroCache = {};
  var _shopifyPriceTimer = null;

  function loadState() {
    var defaults = {
      wire:   '8/6/8',
      height: 1600,
      length: 5,
      color:  'RAL 6005',
      post:   'abdeck',
      mount:  'aufduebeln',
      gate:   'none',
      mitMontage: false,
      extras: {},
      _open:  'length',
      _saved: null,
    };
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        var merged = Object.assign({}, defaults, JSON.parse(raw));
        if (merged.post === 'klemm' || merged.post === 'schweiss' || merged.post === 'u-buegel') {
          merged.post = 'abdeck';
        }
        if (merged.extras && merged.extras.montage) {
          merged.mitMontage = true;
          delete merged.extras.montage;
        }
        merged.mitMontage =
          merged.mitMontage === true || merged.mitMontage === '1' || merged.mitMontage === 1;
        merged.extras = {};
        return merged;
      }
    } catch (e) {}
    return defaults;
  }

  function saveState() {
    try {
      state._open = openSection;
      state._saved = new Date().toISOString();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function resetState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    state = { wire: '8/6/8', height: 1600, length: 5, color: 'RAL 6005', post: 'abdeck', mount: 'aufduebeln', gate: 'none', mitMontage: false, extras: {}, _open: 'length', _saved: null, lengthFromCanvas: false };
    openSection = 'length';
    doneSections = {};
    liveShopify = { panelEuro: null, postEuro: null, panelSku: '', postSku: '', failedKey: null };
    render();
  }

  /* ── Pricing ─────────────────────────────────────────────── */
  function computeTotals() {
    var lengthM = state.length;
    var fields  = Math.ceil(lengthM / 2.5);
    var posts   = fields + 1;

    var post  = find(DATA.POSTS,  function (p) { return p.id === state.post; })     || DATA.POSTS[0];
    var mount = find(DATA.MOUNTS, function (m) { return m.id === state.mount; })    || DATA.MOUNTS[0];
    var gate  = find(DATA.GATES,  function (g) { return g.id === state.gate; })     || DATA.GATES[0];

    var panelSku = 'panel-' + (state.height + 230);
    var postSku  = DATA.POST_SKUS[state.height] || 'post-h240';

    var panelPriceTable = DATA.PANEL_PRICES[state.wire] || DATA.PANEL_PRICES['8/6/8'];
    var panelPriceCatalog = panelPriceTable[state.height] || panelPriceTable[1600];
    var basePostCatalog = DATA.POST_BASE_PRICES[state.height] || DATA.POST_BASE_PRICES[1600];

    var panelUnit = panelPriceCatalog;
    var panelSource = 'katalog';
    if (liveShopify.panelEuro != null && liveShopify.panelSku === panelSku) {
      panelUnit = liveShopify.panelEuro;
      panelSource = 'shopify';
    }

    var postBaseUnit = basePostCatalog;
    var postSource = 'katalog';
    if (liveShopify.postEuro != null && liveShopify.postSku === postSku) {
      postBaseUnit = liveShopify.postEuro;
      postSource = 'shopify';
    }
    var postSurcharge = post.surcharge || 0;
    var postUnitWithSurcharge = postBaseUnit + postSurcharge;

    var fenceCost = panelUnit * fields;
    var postCost  = postUnitWithSurcharge * posts;

    var mountCost  = mount.surcharge * lengthM;
    var gateCost   = DATA.SHOW_GATE_SECTION ? gate.price : 0;
    var profMontageCost = state.mitMontage ? fields * DATA.MONTAGE_PANEL_EUR : 0;

    var extrasCost = 0;
    var extras = state.extras || {};
    var extrasLines = [];
    var catExtrasForTotals = boot && boot.shopifyCatalog && boot.shopifyCatalog.extras;
    for (var id in extras) {
      if (!extras[id]) continue;
      if (id === 'montage') continue;
      var e = find(DATA.EXTRAS, function (x) { return x.id === id; });
      if (!e) continue;
      if (e.requiresGate && (!DATA.SHOW_GATE_SECTION || state.gate === 'none')) continue;
      if (
        catExtrasForTotals &&
        isCatalogSkuSoldOut(catExtrasForTotals, e.cartSkus && e.cartSkus.length ? e.cartSkus : [e.cartSku], e.matchTitleHints)
      ) {
        continue;
      }
      var lineAmt = 0;
      var qtyLabel = '';
      if (e.perPost) {
        lineAmt = e.price * posts;
        qtyLabel = posts + ' Stk.';
      } else if (e.perMeter) {
        lineAmt = e.price * lengthM;
        qtyLabel = lengthM + ' m';
      } else {
        lineAmt = e.price;
        qtyLabel = '1';
      }
      extrasCost += lineAmt;
      if (lineAmt !== 0) extrasLines.push({ label: e.label, qty: qtyLabel, subtotal: lineAmt });
    }

    var total = Math.max(0, fenceCost + postCost + mountCost + gateCost + profMontageCost + extrasCost);

    var heightFactor = state.height / 1600;
    var wireWeights = { '6/5/6': 11, '8/6/8': 17 };
    var weight = Math.round((wireWeights[state.wire] || 17) * lengthM * heightFactor + posts * 8);

    return {
      lengthM: lengthM, fields: fields, posts: posts, total: total, weight: weight,
      fenceCost: fenceCost, postCost: postCost, mountCost: mountCost, gateCost: gateCost,
      profMontageCost: profMontageCost, extrasCost: extrasCost,
      panelPrice: panelUnit, postPrice: postUnitWithSurcharge,
      panelSku: panelSku, postSku: postSku,
      panelSource: panelSource, postSource: postSource,
      postBaseUnit: postBaseUnit, postSurcharge: postSurcharge,
      mountLabel: mount.label, gateLabel: gate.label,
      extrasLines: extrasLines,
    };
  }

  function formatPrice(n) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  /* ── Fence SVG visual ────────────────────────────────────── */
  function buildFenceSVG() {
    var color = find(DATA.COLORS, function (c) { return c.ral === state.color; }) || DATA.COLORS[0];
    var isVerzinkt = state.color === 'feuerverzinkt';
    var panelW = 220;
    var heightRatio = Math.min(1, (state.height - 800) / (2200 - 800));
    var fenceH = Math.round(80 + heightRatio * 200);
    var wireMap = { '6/5/6': 1.6, '8/6/8': 2.2, '8/8/8': 2.6 };
    var wireT = wireMap[state.wire] || 2.2;
    var totalW = panelW * 2 + 40;
    var svgH = fenceH + 60;
    var postX = [0, panelW + 20, panelW * 2 + 20];
    // For feuerverzinkt, use a gradient stroke to simulate metallic sheen
    var wireColor = isVerzinkt ? '#9EABB0' : color.hex;
    var postColor = isVerzinkt ? '#A8B4B8' : color.hex;

    var pairs = Math.max(3, Math.round(fenceH / 70));
    var hRows = [];
    for (var i = 0; i < pairs; i++) {
      var y = 12 + ((fenceH - 24) * i) / (pairs - 1);
      hRows.push(y);
    }

    var displayH = svgH; // matches viewBox so aspect ratio is consistent
    var svgParts = ['<svg viewBox="0 0 ' + totalW + ' ' + svgH + '" width="' + totalW + '" height="' + displayH + '" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" style="overflow:visible;transition:width 0.4s,height 0.3s">'];

    // shadow
    svgParts.push('<ellipse cx="' + (panelW + 20) + '" cy="' + (fenceH + 50) + '" rx="' + Math.round(panelW * 1.05) + '" ry="9" fill="rgba(30,30,30,0.18)"/>');

    // posts
    postX.forEach(function (x) {
      svgParts.push(
        '<rect x="' + (x - 7) + '" y="0" width="14" height="' + (fenceH + 32) + '" fill="' + postColor + '" stroke="rgba(0,0,0,0.18)" stroke-width="0.5"/>',
        '<rect x="' + (x - 5) + '" y="0" width="2" height="' + (fenceH + 32) + '" fill="rgba(255,255,255,' + (isVerzinkt ? '0.35' : '0.18') + ')"/>',
        '<rect x="' + (x - 8) + '" y="-3" width="16" height="4" fill="' + postColor + '" stroke="rgba(0,0,0,0.2)" stroke-width="0.5"/>',
        '<rect x="' + (x - 12) + '" y="' + (fenceH + 32) + '" width="24" height="4" fill="' + postColor + '" opacity="0.85"/>'
      );
      if (state.post === 'klemm') {
        svgParts.push(
          '<rect x="' + (x - 11) + '" y="' + Math.round(fenceH * 0.18) + '" width="22" height="6" fill="oklch(0.85 0.005 250)" stroke="rgba(0,0,0,0.2)" stroke-width="0.4"/>',
          '<rect x="' + (x - 11) + '" y="' + Math.round(fenceH * 0.82) + '" width="22" height="6" fill="oklch(0.85 0.005 250)" stroke="rgba(0,0,0,0.2)" stroke-width="0.4"/>'
        );
      }
    });

    // panels
    for (var p = 0; p < 2; p++) {
      var ox = 10 + p * (panelW + 20);
      for (var vi = 0; vi < 22; vi++) {
        var vx = ox + (panelW * (vi + 0.5)) / 22;
        svgParts.push('<line x1="' + vx.toFixed(1) + '" y1="4" x2="' + vx.toFixed(1) + '" y2="' + (fenceH - 4) + '" stroke="' + wireColor + '" stroke-width="' + wireT + '" stroke-linecap="round"/>');
      }
      hRows.forEach(function (ry) {
        [-2.5, 2.5].forEach(function (off) {
          var lineY = (ry + off).toFixed(1);
          svgParts.push('<line x1="' + ox + '" y1="' + lineY + '" x2="' + (ox + panelW) + '" y2="' + lineY + '" stroke="' + wireColor + '" stroke-width="' + (wireT + 0.3).toFixed(1) + '" stroke-linecap="round"/>');
        });
        [-2.5, 2.5].forEach(function (off) {
          svgParts.push('<line x1="' + ox + '" y1="' + (ry + off).toFixed(1) + '" x2="' + (ox + panelW) + '" y2="' + (ry + off).toFixed(1) + '" stroke="white" stroke-width="0.6" opacity="' + (isVerzinkt ? '0.55' : '0.35') + '"/>');
        });
      });
    }

    svgParts.push('</svg>');
    return { html: svgParts.join(''), width: totalW, height: displayH };
  }

  /* ── SVG icons ───────────────────────────────────────────── */
  var ICON_CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_CHEVRON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>';
  var ICON_SAVE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
  var ICON_ARROW = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

  /* ── Post SVG for option cards ───────────────────────────── */
  function postSVG(id) {
    var klemm = id === 'klemm' ? '<rect x="30" y="22" width="20" height="6" fill="oklch(0.85 0.005 250)" stroke="oklch(0.40 0.01 250)" stroke-width="0.5"/><rect x="30" y="60" width="20" height="6" fill="oklch(0.85 0.005 250)" stroke="oklch(0.40 0.01 250)" stroke-width="0.5"/>' : '';
    var schweiss = id === 'schweiss' ? '<rect x="20" y="24" width="40" height="3" fill="oklch(0.30 0.01 250)"/><rect x="20" y="62" width="40" height="3" fill="oklch(0.30 0.01 250)"/>' : '';
    var ubuegel = id === 'u-buegel' ? '<path d="M28 24 L28 28 L52 28 L52 24" stroke="oklch(0.30 0.01 250)" stroke-width="2" fill="none"/><path d="M28 62 L28 66 L52 66 L52 62" stroke="oklch(0.30 0.01 250)" stroke-width="2" fill="none"/>' : '';
    var lineY = id === 'schweiss' ? '' : '<line x1="20" y1="32" x2="60" y2="32" stroke="oklch(0.30 0.01 250)" stroke-width="1.5"/><line x1="20" y1="65" x2="60" y2="65" stroke="oklch(0.30 0.01 250)" stroke-width="1.5"/>';
    return '<svg viewBox="0 0 80 90" width="60" height="68"><rect x="36" y="6" width="8" height="80" fill="oklch(0.30 0.01 250)"/><rect x="36" y="6" width="2" height="80" fill="rgba(255,255,255,0.2)"/>' + klemm + schweiss + ubuegel + lineY + '</svg>';
  }

  function mountSVG(id) {
    var base = id === 'aufduebeln' ? '<rect x="28" y="42" width="24" height="3" fill="oklch(0.30 0.01 250)"/><circle cx="32" cy="46" r="1" fill="oklch(0.20 0.01 250)"/><circle cx="48" cy="46" r="1" fill="oklch(0.20 0.01 250)"/>' : '';
    var beton = id === 'einbetonieren' ? '<rect x="36" y="42" width="8" height="22" fill="oklch(0.25 0.01 250)"/><rect x="28" y="42" width="24" height="22" fill="oklch(0.78 0.005 250)" opacity="0.55"/>' : '';
    var spike = id === 'einschlagen' ? '<polygon points="36,42 44,42 40,64" fill="oklch(0.25 0.01 250)"/>' : '';
    return '<svg viewBox="0 0 80 70" width="60" height="56" style="margin-top:6px"><rect x="36" y="2" width="8" height="40" fill="oklch(0.25 0.01 250)"/>' + base + beton + spike + '</svg>';
  }

  function gateSVG(id) {
    var fence = '<rect x="2" y="30" width="36" height="2" fill="oklch(0.45 0.01 250)"/><rect x="82" y="30" width="36" height="2" fill="oklch(0.45 0.01 250)"/>';
    var single = (id === 'single' || id === 'both') ? '<rect x="50" y="10" width="20" height="36" fill="none" stroke="oklch(0.30 0.01 250)" stroke-width="1.5"/><line x1="52" y1="12" x2="52" y2="44" stroke="oklch(0.30 0.01 250)" stroke-width="0.7"/><line x1="56" y1="12" x2="56" y2="44" stroke="oklch(0.30 0.01 250)" stroke-width="0.7"/><line x1="60" y1="12" x2="60" y2="44" stroke="oklch(0.30 0.01 250)" stroke-width="0.7"/><line x1="64" y1="12" x2="64" y2="44" stroke="oklch(0.30 0.01 250)" stroke-width="0.7"/>' : '';
    var dbl = (id === 'double' || id === 'both') ? '<rect x="' + (id === 'both' ? '10' : '30') + '" y="10" width="60" height="36" fill="none" stroke="oklch(0.30 0.01 250)" stroke-width="1.5"/><line x1="' + (id === 'both' ? '40' : '60') + '" y1="10" x2="' + (id === 'both' ? '40' : '60') + '" y2="46" stroke="oklch(0.30 0.01 250)" stroke-width="1.2"/>' : '';
    var none = id === 'none' ? '<rect x="40" y="14" width="40" height="32" fill="oklch(0.45 0.01 250)" opacity="0.3"/>' : '';
    return '<svg viewBox="0 0 120 50" width="90%" height="80%">' + fence + none + dbl + single + '</svg>';
  }

  /* ── Section renderers ───────────────────────────────────── */
  function renderHeightBody() {
    var v = state.height;
    var ticks = [800, 1000, 1200, 1400, 1600, 1800, 2000, 2200];
    var options = DATA.HEIGHTS.map(function (h) {
      return '<button class="hk-option-card ' + (v === h.value ? 'is-active' : '') + '" data-action="height" data-value="' + h.value + '" style="text-align:center;padding:9px 4px">' +
        '<div style="font-size:15px;font-weight:600;font-family:var(--mono);letter-spacing:-0.01em">' + h.value + '</div>' +
      '</button>';
    }).join('');
    var ticksHtml = ticks.map(function (t) {
      return '<span style="color:' + (t === v ? 'var(--ink)' : '') + ';font-weight:' + (t === v ? '600' : '400') + '">' + (t / 10) + '</span>';
    }).join('');

    return '<div class="hk-slider-wrap">' +
        '<div class="hk-slider-row">' +
          '<div class="hk-slider-track"><input type="range" min="800" max="2200" step="200" value="' + v + '" data-bind="height"/></div>' +
          '<div class="hk-num-display"><span data-live="height">' + v + '</span><span class="unit">mm</span></div>' +
        '</div>' +
        '<div class="hk-ticks">' + ticksHtml + '</div>' +
      '</div>' +
      '<div class="hk-option-grid" style="grid-template-columns:repeat(4,1fr);gap:6px">' + options + '</div>';
  }

  function renderLengthBody() {
    var v = state.length;
    var fields = Math.ceil(v / 2.5);
    var verschnitt = ((fields * 2.5) - v).toFixed(2);
    var fromCanvas =
      typeof window.__hkCanvasHasClosedShape === 'function' && window.__hkCanvasHasClosedShape();
    var disabledAttr = fromCanvas ? ' disabled' : '';
    var canvasBadge = fromCanvas
      ? '<div class="hk-canvas-badge">Aus Zeichnung übernommen · <span data-live="length">' + v + '</span> m</div>'
      : '';
    return '<p class="hk-help">Gesamtlänge Ihrer Zaunlinie. Wir liefern in Modulen à <span class="num">2,50 m</span> — Restmeter werden zugeschnitten.</p>' +
      canvasBadge +
      '<div style="display:grid;grid-template-columns:1fr auto;gap:18px;align-items:center' + (fromCanvas ? ';opacity:0.4;pointer-events:none' : '') + '">' +
        '<div class="hk-slider-wrap">' +
          '<div class="hk-slider-row">' +
            '<div class="hk-slider-track"><input type="range" min="5" max="120" step="1" value="' + v + '" data-bind="length"' + disabledAttr + '/></div>' +
            '<div class="hk-num-display"><span data-live="length">' + v + '</span><span class="unit">m</span></div>' +
          '</div>' +
          '<div class="hk-ticks"><span>5</span><span>20</span><span>40</span><span>60</span><span>80</span><span>100</span><span>120</span></div>' +
        '</div>' +
        '<div class="hk-num-input-wrap">' +
          '<button data-action="length-dec"' + disabledAttr + '>−</button>' +
          '<input type="number" min="5" max="120" value="' + v + '" data-bind="length-num"' + disabledAttr + '/>' +
          '<button data-action="length-inc"' + disabledAttr + '>+</button>' +
        '</div>' +
      '</div>' +
      '<div class="hk-ctx-grid">' +
        '<div class="hk-ctx-card" style="background:var(--bg-surface)"><span class="k">Felder</span><span class="v" style="font-family:var(--mono)" data-spec="fields">' + fields + ' × 2,50 m</span></div>' +
        '<div class="hk-ctx-card" style="background:var(--bg-surface)"><span class="k">Pfosten</span><span class="v" style="font-family:var(--mono)" data-spec="posts">' + (fields + 1) + ' Stk</span></div>' +
        '<div class="hk-ctx-card" style="background:var(--bg-surface)"><span class="k">Verschnitt</span><span class="v" style="font-family:var(--mono)" data-spec="verschnitt">' + verschnitt + ' m</span></div>' +
      '</div>';
  }

  function renderWireBody() {
    var wireImgs = (typeof window !== 'undefined' && window.HK_WIRE_IMAGES) || {};
    var cards = DATA.WIRES.map(function (w) {
      var active = state.wire === w.value;
      var imgSrc = wireImgs[w.value] || '';
      var imgHtml = imgSrc
        ? '<div class="visual" style="padding:0;overflow:hidden;border-radius:var(--radius-sm) var(--radius-sm) 0 0;height:100px"><img src="' + imgSrc + '" alt="' + w.label + '" style="width:100%;height:100%;object-fit:cover"/></div>'
        : '<div class="visual" style="height:100px;background:var(--bg-surface)"></div>';
      var wp = typeof w.price === 'number' ? w.price : 0;
      var priceStr = wp === 0 ? 'inklusive' : '+' + wp.toFixed(2) + ' €/m';
      var badge = w.value === '8/6/8' ? '<span style="background:var(--accent);color:white;font-size:10px;font-weight:600;padding:2px 7px;border-radius:999px;margin-left:6px;font-family:var(--mono);letter-spacing:0.04em">BELIEBT</span>' : '';
      return '<button class="hk-option-card ' + (active ? 'is-active' : '') + '" data-action="wire" data-value="' + w.value + '" style="padding:0;overflow:hidden">' +
        imgHtml +
        '<div style="padding:10px 12px">' +
          '<div class="lbl" style="margin-bottom:4px"><span>' + w.label + badge + '</span><span class="price">' + priceStr + '</span></div>' +
          '<div class="desc">' + w.desc + '</div>' +
        '</div>' +
        '<div class="check">' + ICON_CHECK + '</div>' +
      '</button>';
    }).join('');
    return '<div class="hk-option-grid cols-2">' + cards + '</div>';
  }

  function renderColorBody() {
    var cur = find(DATA.COLORS, function (c) { return c.ral === state.color; }) || DATA.COLORS[0];
    var swatches = DATA.COLORS.map(function (c) {
      var active = state.color === c.ral;
      var checkBg = c.light ? 'var(--ink)' : 'var(--bg)';
      var checkColor = c.light ? 'var(--bg)' : 'var(--ink)';
      var checkHtml = active ? '<span class="swatch-check" style="background:' + checkBg + ';color:' + checkColor + '">' + ICON_CHECK + '</span>' : '';
      return '<button class="hk-swatch ' + (active ? 'is-active' : '') + ' ' + (c.light ? 'light' : '') + '" style="background:' + c.hex + '" data-action="color" data-value="' + c.ral + '" title="' + c.ral + ' — ' + c.name + '">' +
        '<span class="ral">' + c.ral.replace('RAL ', '') + '</span>' + checkHtml +
      '</button>';
    }).join('');
    return '<p class="hk-help">Pulverbeschichtung nach RAL. Witterungsbeständig, UV-stabil, 10 Jahre Garantie auf den Beschichtungsaufbau.</p>' +
      '<div class="hk-swatch-grid cols-3">' + swatches + '</div>' +
      '<div class="hk-swatch-meta"><span>Ausgewählt: <b>' + cur.ral + '</b> · ' + cur.name + '</span><span>Beschichtung: <b>Pulver, glatt matt</b></span></div>';
  }

  function renderPostBody() {
    var p = find(DATA.POSTS, function (x) { return x.id === state.post; }) || DATA.POSTS[0];
    var basePost = DATA.POST_BASE_PRICES[state.height] || DATA.POST_BASE_PRICES[1600] || 0;
    var unit = basePost + (p.surcharge || 0);
    var imgUrl = bootAssets.postAbdeckleiste || '';
    var visual = imgUrl
      ? '<img src="' + imgUrl + '" alt="Mit Abdeckleiste" width="80" height="80" style="object-fit:contain;width:80px;height:80px">'
      : postSVG(p.id);
    return (
      '<p class="hk-help">Zaunpfosten mit Abdeckleiste — wie im Doppelstab-Konfigurator.</p>' +
      '<div class="hk-option-grid cols-h">' +
      '<button type="button" class="hk-option-card is-active" data-action="post" data-value="abdeck">' +
      '<div class="visual">' + visual + '</div>' +
      '<div class="lbl"><span>' + p.label + '</span><span class="price">' + unit.toFixed(2) + ' €/Stk</span></div>' +
      '<div class="check">' + ICON_CHECK + '</div></button></div>'
    );
  }

  function renderMitMontageBody() {
    var ja = state.mitMontage === true;
    var ep = DATA.MONTAGE_PANEL_EUR;
    return (
      '<p class="hk-help">Professionelle Zaunmontage – alles aus einer Hand. Berechnung pro Zaunelement (2,5 m).</p>' +
      '<div class="hk-option-grid cols-h">' +
      '<button type="button" class="hk-option-card' + (ja ? '' : ' is-active') + '" data-action="mitmontage" data-value="0">' +
      '<div class="lbl"><span>Nein</span><span class="price">—</span></div><div class="check">' + ICON_CHECK + '</div></button>' +
      '<button type="button" class="hk-option-card' + (ja ? ' is-active' : '') + '" data-action="mitmontage" data-value="1">' +
      '<div class="lbl"><span>Ja</span><span class="price">' + ep.toFixed(2) + ' €/Panel</span></div>' +
      '<div class="check">' + ICON_CHECK + '</div></button></div>'
    );
  }

  function renderMountBody() {
    var bg = 'linear-gradient(180deg,oklch(0.95 0.01 85) 0%,oklch(0.95 0.01 85) 55%,oklch(0.78 0.025 80) 55%,oklch(0.68 0.03 75) 100%)';
    var cards = DATA.MOUNTS.map(function (m) {
      var active = state.mount === m.id;
      var priceStr = m.surcharge === 0 ? 'inkl.' : (m.surcharge > 0 ? '+' + m.surcharge + ' €/m' : '−' + Math.abs(m.surcharge) + ' €/m');
      return '<button class="hk-option-card ' + (active ? 'is-active' : '') + '" data-action="mount" data-value="' + m.id + '">' +
        '<div class="visual" style="background:' + bg + ';width:52px;height:52px">' + mountSVG(m.id) + '</div>' +
        '<div class="lbl"><span>' + m.label + '</span><span class="price">' + priceStr + '</span></div>' +
        '<div class="check">' + ICON_CHECK + '</div>' +
      '</button>';
    }).join('');
    return '<div class="hk-option-grid cols-h">' + cards + '</div>';
  }

  function renderGateBody() {
    var cards = DATA.GATES.map(function (g) {
      var active = state.gate === g.id;
      var priceStr = g.price === 0 ? '—' : '+' + g.price.toFixed(0) + ' €';
      return '<button class="hk-option-card ' + (active ? 'is-active' : '') + '" data-action="gate" data-value="' + g.id + '">' +
        '<div class="visual" style="width:52px;height:40px;aspect-ratio:unset">' + gateSVG(g.id) + '</div>' +
        '<div class="lbl"><span>' + g.label + '</span><span class="price">' + priceStr + '</span></div>' +
        '<div class="check">' + ICON_CHECK + '</div>' +
      '</button>';
    }).join('');
    return '<div class="hk-option-grid cols-h">' + cards + '</div>';
  }

  function renderExtrasBody() {
    var totals = computeTotals();
    var catExtras = boot && boot.shopifyCatalog && boot.shopifyCatalog.extras;
    var rows = DATA.EXTRAS.filter(function (e) { return e.id !== 'montage'; }).map(function (e) {
      var checked = !!(state.extras || {})[e.id];
      var soldOut =
        catExtras &&
        isCatalogSkuSoldOut(catExtras, e.cartSkus && e.cartSkus.length ? e.cartSkus : [e.cartSku], e.matchTitleHints);
      var disabled = (e.requiresGate && (!DATA.SHOW_GATE_SECTION || state.gate === 'none')) || soldOut;
      var priceStr = e.perPost ? e.price.toFixed(2) + ' €/Pfosten' : e.perMeter ? e.price.toFixed(0) + ' €/m' : e.price.toFixed(2) + ' €';
      var checkHtml = checked ? ICON_CHECK : '';
      return '<div class="hk-extra-row ' + (checked ? 'is-checked' : '') + ' ' + (disabled ? 'is-disabled' : '') + '" data-action="extra" data-value="' + e.id + '" style="' + (disabled ? 'pointer-events:none' : '') + '">' +
        '<span class="hk-checkbox">' + checkHtml + '</span>' +
        '<div><div class="extra-lbl">' + e.label + (soldOut ? ' <span style="color:#b45309;font-weight:600">· Ausverkauft</span>' : '') + '</div><div class="extra-desc">' + e.desc + '</div></div>' +
        '<span class="extra-price">' + priceStr + '</span>' +
      '</div>';
    }).join('');
    return '<p class="hk-help">Optionales Zubehör. Direkt mit Ihrer Bestellung versendet.</p>' +
      '<div class="hk-extras-list">' + rows + '</div>';
  }

  /* ── Section definitions ─────────────────────────────────── */
  function getSectionDefs() {
    var t = computeTotals();
    return [
      { id: 'length', num: '01', title: 'Zaunlänge',       summary: '<b>' + state.length + ' m</b> · ' + t.fields + ' Felder',                  body: renderLengthBody },
      { id: 'height', num: '02', title: 'Höhe',            summary: '<b>' + state.height + ' mm</b> · ' + (state.height / 10) + ' cm',          body: renderHeightBody },
      { id: 'wire',   num: '03', title: 'Drahtstärke',     summary: '<b>' + state.wire + '</b> mm',                                              body: renderWireBody },
      { id: 'color',  num: '04', title: 'Beschichtung',    summary: '<b>' + state.color + '</b>',                                                body: renderColorBody },
      { id: 'post',   num: '05', title: 'Pfostenausführung', summary: '<b>' + (find(DATA.POSTS, function (p) { return p.id === state.post; }) || DATA.POSTS[0]).label + '</b>', body: renderPostBody },
      { id: 'mount',  num: '06', title: 'Montageart',      summary: '<b>' + (find(DATA.MOUNTS, function (m) { return m.id === state.mount; }) || DATA.MOUNTS[0]).label + '</b>', body: renderMountBody },
      { id: 'mitmontage', num: '07', title: 'Mit Montage', summary: state.mitMontage ? '<b>Ja</b> · ' + t.fields + ' × ' + DATA.MONTAGE_PANEL_EUR + ' €' : '<b>Nein</b>', body: renderMitMontageBody },
    ];
  }

  /* ── Render ──────────────────────────────────────────────── */
  var root;

  function render() {
    if (!root) return;
    var totals = computeTotals();
    renderPreview(totals);
    renderHeroMeta(totals);
    renderConfig(totals);
    renderStickyBar(totals);
    renderInfoBanner();
    scheduleShopifyPriceSync();
    // React-Grundriss (Konfigurator-Section) lauscht darauf und aktualisiert die linke Materialliste
    try {
      document.dispatchEvent(new CustomEvent('hk-state-changed'));
    } catch (e) {}
    try {
      if (typeof window.__hkSyncEmbFloat === 'function') window.__hkSyncEmbFloat();
    } catch (e) {}
  }

  function renderPreview(totals) {
    var fence = buildFenceSVG();
    var color = find(DATA.COLORS, function (c) { return c.ral === state.color; }) || DATA.COLORS[0];

    var fenceWrap = root.querySelector('.hk-fence-wrap');
    if (fenceWrap) {
      // Width scales with length: 200px at 5m → 300px at 120m (50% wider at max)
      // Height scales with height setting using a fixed 240px reference — independent
      var lengthRatio = Math.min(1, (state.length - 5) / (120 - 5));
      var embW = Math.round(200 + lengthRatio * 100);
      var embH = Math.round(fence.height * (240 / fence.width)); // always based on 240px ref
      fenceWrap.innerHTML = fence.html.replace(
        'width="' + fence.width + '" height="' + fence.height + '"',
        'width="' + embW + '" height="' + embH + '"'
      );
    }

    // Update floating preview
    var floatPreview = document.getElementById('hk-float-preview');
    if (floatPreview) {
      var floatFence = floatPreview.querySelector('.hk-float-fence');
      if (floatFence) {
        // Same independent scaling as main preview: width from length, height from fixed ref
        var floatLengthRatio = Math.min(1, (state.length - 5) / (120 - 5));
        var floatW = Math.round(140 + floatLengthRatio * 70); // 140px at 5m → 210px at 120m
        var floatH = Math.round(fence.height * (160 / fence.width)); // height based on 160px ref
        floatFence.innerHTML = fence.html.replace(
          'width="' + fence.width + '" height="' + fence.height + '"',
          'width="' + floatW + '" height="' + floatH + '"'
        );
      }
      var floatHeight = floatPreview.querySelector('.hk-float-height');
      if (floatHeight) floatHeight.textContent = state.height + ' mm';
      var floatLength = floatPreview.querySelector('.hk-float-length');
      if (floatLength) floatLength.textContent = state.length + ' m · ' + Math.ceil(state.length / 2.5) + ' Felder';
    }

    var pill = root.querySelector('.hk-preview-pill');
    if (pill) pill.textContent = state.length + ' m · ' + state.height + ' mm';

    var dimPill = root.querySelector('.hk-dim-pill');
    if (dimPill) dimPill.textContent = state.height + ' mm';

    var infoCard = root.querySelector('.hk-info-card');
    if (infoCard) {
      var isVerzinkt = state.color === 'feuerverzinkt';
      infoCard.innerHTML =
        '<span class="k">' + (isVerzinkt ? 'OBERFLÄCHE' : 'RAL') + '</span><b class="v">' + (isVerzinkt ? 'Verzinkt' : color.ral.replace('RAL ', '')) + '</b>' +
        '<span class="k">FARBE</span><b class="v" style="text-transform:lowercase">' + color.name + '</b>' +
        '<span class="k">DRAHT</span><b class="v">' + state.wire + '</b>';
    }

    var verschnittVal = ((Math.ceil(totals.lengthM / 2.5) * 2.5) - totals.lengthM).toFixed(2);
    // Keep open section controls in sync with state (slider ↔ buttons)
    var heightRange = root.querySelector('input[data-bind="height"]');
    if (heightRange) heightRange.value = state.height;
    var heightLive = root.querySelector('[data-live="height"]');
    if (heightLive) heightLive.textContent = state.height;
    // Keep length live spans in sync (badge + slider display)
    root.querySelectorAll('[data-live="length"]').forEach(function (el) {
      el.textContent = state.length;
    });
    root.querySelectorAll('[data-action="height"]').forEach(function (btn) {
      btn.classList.toggle('is-active', parseInt(btn.getAttribute('data-value')) === state.height);
    });
    // Update tick highlight for height
    var heightTicks = root.querySelectorAll('.hk-ticks span');
    if (heightTicks.length > 0) {
      heightTicks.forEach(function (t) {
        var tickVal = parseInt(t.textContent) * 10;
        t.style.fontWeight = tickVal === state.height ? '600' : '400';
        t.style.color = tickVal === state.height ? 'var(--ink)' : '';
      });
    }

    // Sync is-active on all option cards (post, mount, gate, wire, color)
    ['wire', 'color', 'post', 'mount', 'gate'].forEach(function (action) {
      root.querySelectorAll('[data-action="' + action + '"]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-value') === state[action]);
      });
    });
    root.querySelectorAll('[data-action="mitmontage"]').forEach(function (btn) {
      var wantJa = btn.getAttribute('data-value') === '1';
      btn.classList.toggle('is-active', wantJa === (state.mitMontage === true));
    });

    // Sync extras checkboxes (body not rebuilt when section stays open)
    var currentExtras = state.extras || {};
    root.querySelectorAll('[data-action="extra"]').forEach(function (row) {
      var id = row.getAttribute('data-value');
      var isChecked = !!currentExtras[id];
      row.classList.toggle('is-checked', isChecked);
      var cb = row.querySelector('.hk-checkbox');
      if (cb) cb.innerHTML = isChecked ? ICON_CHECK : '';
    });

    var specs = root.querySelectorAll('[data-spec]');
    specs.forEach(function (el) {
      var key = el.getAttribute('data-spec');
      if (key === 'fields')     el.textContent = totals.fields + ' × 2,50 m';
      if (key === 'posts')      el.textContent = totals.posts + ' Stk';
      if (key === 'verschnitt') el.textContent = verschnittVal + ' m';
      if (key === 'weight')     el.textContent = '≈ ' + totals.weight + ' kg';
    });
  }

  function renderHeroMeta(totals) {
    var metaWire   = root.querySelector('[data-hero="wire"]');
    var metaHeight = root.querySelector('[data-hero="height"]');
    var metaLength = root.querySelector('[data-hero="length"]');
    if (metaWire)   metaWire.textContent   = state.wire;
    if (metaHeight) metaHeight.textContent = (state.height / 10).toFixed(0) + ' cm';
    if (metaLength) metaLength.textContent = state.length + ' m';
  }

  function renderConfig(totals) {
    var defs = getSectionDefs();
    var configEl = root.querySelector('.hk-config-sections');
    if (!configEl) return;

    // If sections already exist, do a minimal update (summaries + classes only)
    // to avoid destroying active inputs/sliders
    var existing = configEl.querySelectorAll('[data-section]');
    if (existing.length === defs.length) {
      defs.forEach(function (def) {
        var sec = configEl.querySelector('[data-section="' + def.id + '"]');
        if (!sec) return;
        var isOpen = openSection === def.id;
        var isDone = doneSections[def.id] && !isOpen;
        // update classes
        sec.className = 'hk-section ' + (isOpen ? 'is-open' : 'is-collapsed') + (isDone ? ' is-done' : '');
        // update num badge
        var numEl = sec.querySelector('.hk-section-num');
        if (numEl) numEl.innerHTML = isDone ? ICON_CHECK : def.num;
        // update summary
        var sumEl = sec.querySelector('.hk-section-summary');
        if (sumEl) sumEl.innerHTML = def.summary;
        // open/close body
        var bodyEl = sec.querySelector('.hk-section-body');
        if (isOpen && !bodyEl) {
          var newBody = document.createElement('div');
          newBody.className = 'hk-section-body hk-fade-in';
          newBody.innerHTML = def.body();
          sec.appendChild(newBody);
          bindSectionEvents(sec);
        } else if (!isOpen && bodyEl) {
          sec.removeChild(bodyEl);
        } else if (isOpen && bodyEl && def.id === 'mitmontage') {
          bodyEl.innerHTML = def.body();
        }
      });
    } else {
      // First render — build from scratch
      configEl.innerHTML = defs.map(function (def) {
        var isOpen = openSection === def.id;
        var isDone = doneSections[def.id] && !isOpen;
        var cls = 'hk-section ' + (isOpen ? 'is-open' : 'is-collapsed') + (isDone ? ' is-done' : '');
        var numHtml = isDone ? ICON_CHECK : def.num;
        var bodyHtml = isOpen ? '<div class="hk-section-body">' + def.body() + '</div>' : '';
        return '<div class="' + cls + '" data-section="' + def.id + '">' +
          '<div class="hk-section-head">' +
            '<span class="hk-section-num">' + numHtml + '</span>' +
            '<span class="hk-section-title">' + def.title + '</span>' +
            '<div class="hk-section-summary">' + def.summary + '</div>' +
            '<button class="hk-section-toggle">' + ICON_CHEVRON + '</button>' +
          '</div>' +
          bodyHtml +
        '</div>';
      }).join('');
      bindSectionEvents(configEl);
    }

    // progress chips
    var progress = root.querySelector('.hk-progress');
    if (progress) {
      progress.innerHTML = defs.map(function (def) {
        var cls = 'hk-step-chip ' + (openSection === def.id ? 'is-active' : (doneSections[def.id] ? 'is-done' : ''));
        return '<span class="' + cls + '">' + def.num + '</span>';
      }).join('');
    }
  }

  function escPd(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function renderPriceDetail(totals) {
    var el = root.querySelector('.hk-price-detail');
    if (!el) return;
    var embedded = root.classList.contains('hk-embedded');
    var pSrc = totals.panelSource === 'shopify' ? 'Shopify' : 'Tabelle';
    var poSrc = totals.postSource === 'shopify' ? 'Shopify' : 'Tabelle';
    var rows = [];
    if (embedded) {
      rows.push(
        '<tr><td class="hk-pd-k">Panels</td>' +
        '<td class="hk-pd-q">' + totals.fields + ' × ' + formatPrice(totals.panelPrice) + '</td>' +
        '<td class="hk-pd-p">' + formatPrice(totals.fenceCost) + '</td></tr>'
      );
      rows.push(
        '<tr><td class="hk-pd-k">Pfosten</td>' +
        '<td class="hk-pd-q">' + totals.posts + ' × ' + formatPrice(totals.postPrice) + '</td>' +
        '<td class="hk-pd-p">' + formatPrice(totals.postCost) + '</td></tr>'
      );
    } else {
    rows.push(
      '<tr><td class="hk-pd-k">Panels <code>' + escPd(totals.panelSku) + '</code> <span class="hk-pd-src">(' + pSrc + ')</span></td>' +
      '<td class="hk-pd-q">' + totals.fields + ' × ' + formatPrice(totals.panelPrice) + '</td>' +
      '<td class="hk-pd-p">' + formatPrice(totals.fenceCost) + '</td></tr>'
    );
    rows.push(
      '<tr><td class="hk-pd-k">Pfosten <code>' + escPd(totals.postSku) + '</code> <span class="hk-pd-src">(' + poSrc + ')</span></td>' +
      '<td class="hk-pd-q">' + totals.posts + ' × ' + formatPrice(totals.postPrice) + '</td>' +
      '<td class="hk-pd-p">' + formatPrice(totals.postCost) + '</td></tr>'
    );
    }
    if (totals.mountCost !== 0) {
      rows.push(
        '<tr><td class="hk-pd-k">Montage · ' + escPd(totals.mountLabel) + (embedded ? '' : ' <span class="hk-pd-src">(Konfigurator)</span>') + '</td>' +
        '<td class="hk-pd-q">' + totals.lengthM + ' m</td><td class="hk-pd-p">' + formatPrice(totals.mountCost) + '</td></tr>'
      );
    }
    if (totals.profMontageCost > 0) {
      rows.push(
        '<tr><td class="hk-pd-k">Profi-Montage' + (embedded ? '' : ' <span class="hk-pd-src">(Konfigurator)</span>') + '</td>' +
        '<td class="hk-pd-q">' + totals.fields + ' × ' + formatPrice(DATA.MONTAGE_PANEL_EUR) + '</td>' +
        '<td class="hk-pd-p">' + formatPrice(totals.profMontageCost) + '</td></tr>'
      );
    }
    if (DATA.SHOW_GATE_SECTION && totals.gateCost !== 0) {
      rows.push('<tr><td class="hk-pd-k">' + escPd(totals.gateLabel) + (embedded ? '' : ' <span class="hk-pd-src">(Konfigurator)</span>') + '</td><td class="hk-pd-q">1</td><td class="hk-pd-p">' + formatPrice(totals.gateCost) + '</td></tr>');
    }
    for (var i = 0; i < totals.extrasLines.length; i++) {
      var x = totals.extrasLines[i];
      rows.push('<tr><td class="hk-pd-k">' + escPd(x.label) + (embedded ? '' : ' <span class="hk-pd-src">(Konfigurator)</span>') + '</td><td class="hk-pd-q">' + escPd(x.qty) + '</td><td class="hk-pd-p">' + formatPrice(x.subtotal) + '</td></tr>');
    }
    rows.push('<tr class="hk-pd-sum"><td colspan="2"><b>Summe</b> <span class="hk-pd-w">inkl. 19 % MwSt.</span></td><td class="hk-pd-p"><b>' + formatPrice(totals.total) + '</b></td></tr>');
    var tableHtml = '<table class="hk-pd-table" role="presentation"><tbody>' + rows.join('') + '</tbody></table>';
    if (embedded) {
      el.innerHTML =
        '<details class="hk-pd-collapse">' +
        '<summary class="hk-pd-collapse-sum">Preisaufschlüsselung</summary>' +
        '<div class="hk-pd-sub">' + escPd(state.wire) + ' · ' + state.height + ' mm · ' + state.length + ' m</div>' +
        tableHtml +
        '</details>';
      return;
    }
    var foot =
      'Live-Preise für Panel und Pfosten (Shopify). Tor, Zubehör und Aufpreise erscheinen als eigene Warenkorb-Positionen. ';
    if (totals.mountCost < 0) {
      foot += 'Montage-Rabatt (z. B. Einschlaghülsen) ist in der Summe enthalten.';
    }
    el.innerHTML =
      '<div class="hk-pd-title">Preisdetails</div>' +
      '<div class="hk-pd-sub">' + escPd(state.wire) + ' · ' + state.height + ' mm · ' + state.length + ' m Zaunlänge</div>' +
      tableHtml +
      '<p class="hk-pd-foot">' + foot + '</p>';
  }

  function renderStickyBar(totals) {
    var color = find(DATA.COLORS, function (c) { return c.ral === state.color; }) || DATA.COLORS[0];

    var priceEl = root.querySelector('.hk-price-val');
    if (priceEl) priceEl.textContent = formatPrice(totals.total);

    renderPriceDetail(totals);

    var summaryEl = root.querySelector('.hk-summary-list');
    if (summaryEl) {
      summaryEl.innerHTML =
        '<div class="item"><b>' + state.wire + '</b></div>' +
        '<div class="sep"></div>' +
        '<div class="item"><b>' + state.height + ' mm</b> Höhe</div>' +
        '<div class="sep"></div>' +
        '<div class="item"><b>' + state.length + ' m</b> Länge</div>' +
        '<div class="sep"></div>' +
        '<div class="item"><span class="hk-color-dot" style="background:' + color.hex + '"></span><b>' + state.color.replace('RAL ', '') + '</b></div>' +
        '<div class="sep"></div>' +
        '<div class="item">' + totals.posts + ' <b>Pfosten</b></div>' +
        '<div class="sep"></div>' +
        '<div class="item" style="font-family:var(--mono);font-size:12px;color:var(--ink-mute)">≈ ' + totals.weight + ' kg</div>';
    }
  }

  function renderInfoBanner() {
    var banner = root.querySelector('.hk-info-banner');
    if (!banner) return;
    if (state._saved) {
      var d = new Date(state._saved);
      var dateStr = d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
      banner.style.display = 'flex';
      var textEl = banner.querySelector('.hk-banner-text');
      if (textEl) textEl.textContent = 'Letzte Konfiguration vom ' + dateStr + ' wiederhergestellt.';
    } else {
      banner.style.display = 'none';
    }
  }

  /* ── Event binding (called once on init, uses delegation) ── */
  var _eventsWired = false;
  function bindSectionEvents(el) { /* no-op — delegation handles it */ }

  function wireEvents() {
    if (_eventsWired) return;
    _eventsWired = true;

    var configEl = root.querySelector('.hk-config-sections');

    // Section head toggle (delegation)
    configEl.addEventListener('click', function (e) {
      // section head toggle
      var head = e.target.closest('.hk-section-head');
      if (head) {
        var sec = head.closest('[data-section]');
        if (!sec) return;
        var id = sec.getAttribute('data-section');
        if (openSection === id) {
          doneSections[id] = true;
          openSection = null;
        } else {
          if (openSection) doneSections[openSection] = true;
          openSection = id;
        }
        render();
        return;
      }

      // action buttons
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');
      var value  = btn.getAttribute('data-value');
      if (action === 'height') { state.height = parseInt(value); render(); }
      if (action === 'wire')   { state.wire   = value; render(); }
      if (action === 'color')  { state.color  = value; render(); }
      if (action === 'post')   { state.post   = value; render(); }
      if (action === 'mount')  { state.mount  = value; render(); }
      if (action === 'mitmontage') { state.mitMontage = value === '1'; render(); }
      if (action === 'gate')   { state.gate   = value; render(); }
      if (action === 'extra') {
        var extras = {};
        var old = state.extras || {};
        for (var k in old) extras[k] = old[k];
        extras[value] = !extras[value];
        state.extras = extras;
        render();
      }
      if (action === 'length-dec') { state.length = Math.max(5, state.length - 1); render(); }
      if (action === 'length-inc') { state.length = Math.min(120, state.length + 1); render(); }
    });

    // Range sliders — input: lightweight live update, change: full render on release
    configEl.addEventListener('input', function (e) {
      var input = e.target;
      if (input.tagName !== 'INPUT' || input.type !== 'range') return;
      var key = input.getAttribute('data-bind');
      if (!key) return;
      var val = parseInt(input.value);
      state[key] = val;
      var live = configEl.querySelector('[data-live="' + key + '"]');
      if (live) live.textContent = val;
      if (key === 'length') {
        var numInput = configEl.querySelector('input[data-bind="length-num"]');
        if (numInput) numInput.value = val;
      }
      var totals = computeTotals();
      renderPreview(totals);
      renderHeroMeta(totals);
      renderStickyBar(totals);
    });

    configEl.addEventListener('change', function (e) {
      var input = e.target;
      if (input.tagName !== 'INPUT') return;
      if (input.type === 'range') {
        render(); // full re-render on slider release (tick highlights, sub-cards)
      }
      if (input.getAttribute('data-bind') === 'length-num') {
        var v = Math.min(120, Math.max(5, parseInt(input.value) || 5));
        state.length = v;
        render();
      }
    });
  }

  /* ── Cart ────────────────────────────────────────────────── */
  function showNoVariantPreview(props, totals, opts) {
    opts = opts || {};
    var existing = document.getElementById('hk-novariant-overlay');
    if (existing) existing.remove();

    var rows = Object.keys(props).map(function (k) {
      return '<tr><td style="padding:5px 12px 5px 0;color:#8a9aa4;font-size:0.82em;white-space:nowrap">' + k + '</td>' +
             '<td style="padding:5px 0;font-weight:500;font-size:0.85em">' + props[k] + '</td></tr>';
    }).join('');

    var soldOut = !!(opts.panelSoldOut || opts.postSoldOut);
    var subtitle = soldOut
      ? 'Produkte sind aktiv — aber für den Online-Shop nicht kaufbar (Lager / Standort)'
      : 'Kein Shopify-Produkt konfiguriert – diese Daten würden übergeben';
    var helpTitle = soldOut
      ? 'Nächster Schritt — Online-Lager freischalten'
      : 'Nächster Schritt — Produkte aktivieren';
    var helpBody = soldOut
      ? '<b>1.</b> Shopify Admin → <b>Einstellungen → Standorte</b><br>' +
        '&nbsp;&nbsp;&nbsp;→ <b>Mağaza konumu</b> für <b>Online-Shop-Bestellungen</b> aktivieren<br>' +
        '<b>2.</b> <code>konfigurator-panel</code> + <code>konfigurator-direk</code> → Inventar → Bestand oder „Weiter verkaufen wenn ausverkauft“<br>' +
        '<b>3.</b> Test auf zaunideal.de: gleiche Variante direkt in den Warenkorb<br>' +
        '<b style="color:#1c3845">→ Theme/Konfigurator OK — Shopify lehnt Online-Kauf ab.</b>'
      : '<b>1.</b> Shopify Admin → Produkte → <code>konfigurator-panel</code> → Preis + Aktiv<br>' +
        '<b>2.</b> Shopify Admin → Produkte → <code>konfigurator-direk</code> → Preis + Aktiv<br>' +
        '<b>3.</b> Optional: <code>konfigurator-kapi</code>, <code>konfigurator-zubehoer</code><br>' +
        '<b style="color:#1c3845">→ Danach fügt der Warenkorb Positionen hinzu.</b>';

    var overlay = document.createElement('div');
    overlay.id = 'hk-novariant-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px';
    overlay.innerHTML =
      '<div style="background:#fff;border-radius:10px;max-width:480px;width:100%;max-height:90vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,0.3)">' +
        '<div style="background:#1c3845;color:white;padding:18px 20px;border-radius:10px 10px 0 0;display:flex;align-items:center;justify-content:space-between">' +
          '<div>' +
            '<div style="font-weight:600;font-size:1em">Warenkorb-Vorschau</div>' +
            '<div style="font-size:0.75em;opacity:0.7;margin-top:2px">' + subtitle + '</div>' +
          '</div>' +
          '<button id="hk-novariant-close" style="background:rgba(255,255,255,0.15);border:none;color:white;width:28px;height:28px;border-radius:50%;cursor:pointer;font-size:1em;line-height:1">✕</button>' +
        '</div>' +
        '<div style="padding:20px">' +
          '<table style="width:100%;border-collapse:collapse">' + rows + '</table>' +
          '<div style="margin-top:16px;padding:12px 16px;background:#f5f8f9;border-radius:6px;border-left:3px solid #1c3845">' +
            '<div style="font-size:0.78em;color:#1c3845;font-weight:600;margin-bottom:6px">' + helpTitle + '</div>' +
            '<div style="font-size:0.78em;color:#556;line-height:1.8">' + helpBody + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    document.getElementById('hk-novariant-close').addEventListener('click', function () { overlay.remove(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
  }

  // ── Cart: lookup variant IDs from Shopify storefront, add multiple items ──
  // SKU- und Varianten-Detail-Cache: window.ZaunIdealKonfigPricing (konfigurator-pricing-shared.js)

  function fetchVariantEuroById(variantId) {
    if (!variantId) return Promise.resolve(null);
    if (typeof _variantEuroCache[variantId] === 'number') {
      return Promise.resolve(_variantEuroCache[variantId]);
    }
    var P = typeof window !== 'undefined' && window.ZaunIdealKonfigPricing;
    if (!P || !P.fetchVariantDetailById) {
      return Promise.resolve(null);
    }
    return P.fetchVariantDetailById(variantId)
      .then(function (v) {
        if (!v || v.price == null) return null;
        var euro = v.price / 100;
        if (!isNaN(euro)) {
          _variantEuroCache[variantId] = euro;
          return euro;
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function scheduleShopifyPriceSync() {
    if (!root || !root.querySelector('.hk-price-detail')) return;
    var panelSku = 'panel-' + (state.height + 230);
    var postSku = DATA.POST_SKUS[state.height] || 'post-h240';
    var key = panelSku + '|' + postSku;
    if (liveShopify.panelSku === panelSku && liveShopify.postSku === postSku && liveShopify.panelEuro != null && liveShopify.postEuro != null) {
      return;
    }
    if (liveShopify.failedKey === key) return;
    if (_shopifyPriceTimer) clearTimeout(_shopifyPriceTimer);
    _shopifyPriceTimer = setTimeout(function () {
      _shopifyPriceTimer = null;
      Promise.all([
        fetchVariantBySku(DATA.CART_HANDLES.panel, panelSku),
        fetchVariantBySku(DATA.CART_HANDLES.post, postSku),
      ])
        .then(function (ids) {
          var pid = ids[0];
          var qid = ids[1];
          if (!pid || !qid) {
            liveShopify.failedKey = key;
            return;
          }
          return Promise.all([fetchVariantEuroById(pid), fetchVariantEuroById(qid)]).then(function (prices) {
            liveShopify.panelSku = panelSku;
            liveShopify.postSku = postSku;
            liveShopify.panelEuro = prices[0];
            liveShopify.postEuro = prices[1];
            if (prices[0] == null || prices[1] == null) {
              liveShopify.failedKey = key;
            } else {
              liveShopify.failedKey = null;
            }
            render();
          });
        })
        .catch(function () {
          liveShopify.failedKey = key;
        });
    }, 320);
  }

  function fetchVariantBySku(handle, sku) {
    var P = typeof window !== 'undefined' && window.ZaunIdealKonfigPricing;
    if (!P || !P.fetchVariantIdBySku) return Promise.resolve(null);
    return P.fetchVariantIdBySku(handle, sku);
  }

  /** SKU-Vergleich: siehe ZaunIdealKonfigPricing.normalizeCartSku (shared). */
  function normalizeCartSku(s) {
    var P = typeof window !== 'undefined' && window.ZaunIdealKonfigPricing;
    if (P && P.normalizeCartSku) return P.normalizeCartSku(s);
    return String(s == null ? '' : s)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function fetchFirstSkuFromList(handle, skuList) {
    if (!handle || !skuList || !skuList.length) return Promise.resolve(null);
    var i = 0;
    function tryNext() {
      if (i >= skuList.length) return Promise.resolve(null);
      var sku = skuList[i++];
      return fetchVariantBySku(handle, sku).then(function (id) {
        return id || tryNext();
      });
    }
    return tryNext();
  }

  function parseCatalogVariants(bucket) {
    if (!bucket) return [];
    if (typeof bucket === 'string') {
      try {
        bucket = JSON.parse(bucket);
      } catch (e3) {
        return [];
      }
    }
    return Array.isArray(bucket) ? bucket : [];
  }

  function deAccentLower(s) {
    var str = String(s == null ? '' : s).toLowerCase();
    try {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e4) {
      return str;
    }
  }

  function variantIsPurchasable(v) {
    if (!v) return false;
    if (v.available_for_sale === false) return false;
    if (v.inventory_management === 'shopify') {
      if (v.available === false) return false;
      if (v.inventory_policy === 'deny') {
        var q = parseInt(v.inventory_quantity, 10);
        if (!isNaN(q) && q <= 0) return false;
      }
    }
    return true;
  }

  function findCatalogVariant(variants, skuList, titleHintsAny, requirePurchasable) {
    if (!variants || !variants.length) return null;
    var i;
    var j;
    var want;
    var v;
    var vs;
    var vb;
    var t;
    function ok(vv) {
      return vv && (!requirePurchasable || variantIsPurchasable(vv));
    }
    for (i = 0; i < skuList.length; i++) {
      want = normalizeCartSku(skuList[i]);
      if (!want) continue;
      for (j = 0; j < variants.length; j++) {
        v = variants[j];
        if (!ok(v)) continue;
        if (normalizeCartSku(v.sku) === want || normalizeCartSku(v.barcode) === want) return v;
      }
    }
    for (i = 0; i < skuList.length; i++) {
      want = normalizeCartSku(skuList[i]);
      if (!want || want.length < 4) continue;
      for (j = 0; j < variants.length; j++) {
        v = variants[j];
        if (!ok(v)) continue;
        vs = normalizeCartSku(v.sku);
        vb = normalizeCartSku(v.barcode);
        if (vs && (vs.indexOf(want) !== -1 || want.indexOf(vs) !== -1)) return v;
        if (vb && (vb.indexOf(want) !== -1 || want.indexOf(vb) !== -1)) return v;
      }
    }
    if (titleHintsAny && titleHintsAny.length) {
      for (j = 0; j < variants.length; j++) {
        v = variants[j];
        if (!ok(v)) continue;
        t = variantSearchBlob(v);
        for (i = 0; i < titleHintsAny.length; i++) {
          var hint = deAccentLower(titleHintsAny[i] || '');
          if (hint && t.indexOf(hint) !== -1) return v;
        }
      }
    }
    return null;
  }

  function variantSearchBlob(v) {
    if (!v) return '';
    var parts = [
      v.title,
      v.public_title,
      v.name,
      v.option1,
      v.option2,
      v.option3,
      v.sku,
      v.barcode
    ];
    return deAccentLower(
      parts
        .filter(function (p) {
          return p != null && String(p).trim() !== '';
        })
        .join(' ')
    );
  }

  function resolveVariantIdFromCatalog(variants, skuList, titleHintsAny) {
    var v = findCatalogVariant(variants, skuList, titleHintsAny, true);
    return v ? v.id : null;
  }

  function isCatalogSkuSoldOut(catalogBucket, skuList, titleHintsAny) {
    return !!findCatalogVariant(parseCatalogVariants(catalogBucket), skuList, titleHintsAny, false) &&
      !findCatalogVariant(parseCatalogVariants(catalogBucket), skuList, titleHintsAny, true);
  }

  function cacheResolvedSkus(handle, skuList, id) {
    var P = typeof window !== 'undefined' && window.ZaunIdealKonfigPricing;
    if (P && P.primeSkuCache) P.primeSkuCache(handle, skuList, id);
  }

  function resolveFromShopifyCatalogThenFetch(handle, skuList, catalogBucket, titleHintsAny) {
    if (!handle || !skuList || !skuList.length) return Promise.resolve(null);
    var variants = parseCatalogVariants(catalogBucket);
    if (variants.length && isCatalogSkuSoldOut(catalogBucket, skuList, titleHintsAny)) {
      return Promise.resolve(null);
    }
    var manualId = lookupManualVariantMap(skuList);
    if (manualId && variants.length) {
      var mv;
      for (var mvi = 0; mvi < variants.length; mvi++) {
        if (String(variants[mvi].id) === String(manualId)) {
          mv = variants[mvi];
          break;
        }
      }
      if (mv && !variantIsPurchasable(mv)) manualId = null;
    }
    if (manualId) {
      cacheResolvedSkus(handle, skuList, manualId);
      return Promise.resolve(manualId);
    }
    if (variants.length) {
      var cid = resolveVariantIdFromCatalog(variants, skuList, titleHintsAny);
      if (cid) {
        cacheResolvedSkus(handle, skuList, cid);
        return Promise.resolve(cid);
      }
    }
    return fetchFirstSkuFromList(handle, skuList);
  }

  function parseCartAddResponse(r, text) {
    var body = (text || '').trim();
    if (!body) {
      if (!r.ok) throw new Error('Warenkorb: leere Antwort (HTTP ' + r.status + ').');
      return {};
    }
    if (body.charAt(0) === '<') {
      throw new Error('Der Server lieferte HTML statt JSON (HTTP ' + r.status + '). Bitte Seite neu laden; in Theme-Preview / Passwortschutz ggf. im normalen Shop testen.');
    }
    var j;
    try {
      j = JSON.parse(body);
    } catch (e) {
      throw new Error('Warenkorb: ungültige Antwort (HTTP ' + r.status + ').');
    }
    if (!r.ok) {
      var err = new Error((j && j.description) || (j && j.message) || ('HTTP ' + r.status));
      err.status = r.status;
      throw err;
    }
    return j;
  }

  function variantCatalogMaxPurchasable(catalogBucket, variantId) {
    if (!catalogBucket || variantId == null) return null;
    var variants = parseCatalogVariants(catalogBucket);
    var i;
    for (i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (String(v.id) !== String(variantId)) continue;
      if (!variantIsPurchasable(v)) return 0;
      if (v.inventory_management === 'shopify' && v.inventory_policy === 'deny') {
        var q = parseInt(v.inventory_quantity, 10);
        if (!isNaN(q)) return Math.max(0, q);
      }
      return null;
    }
    return null;
  }

  function catalogLabelForVariantId(variantId, catPanel, catPost, catExtras) {
    if (variantCatalogMaxPurchasable(catPanel, variantId) !== null) return DATA.CART_HANDLES.panel;
    if (variantCatalogMaxPurchasable(catPost, variantId) !== null) return DATA.CART_HANDLES.post;
    if (catExtras && variantCatalogMaxPurchasable(catExtras, variantId) !== null) return DATA.CART_HANDLES.extras;
    if (catExtras && findVariantInCatalog(catExtras, variantId)) return DATA.CART_HANDLES.extras;
    return 'Produkt';
  }

  function findVariantInCatalog(catalogBucket, variantId) {
    var variants = parseCatalogVariants(catalogBucket);
    var i;
    for (i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    return null;
  }

  function variantCatalogSoldOut(catalogBucket, variantId) {
    var v = findVariantInCatalog(catalogBucket, variantId);
    if (!v) return false;
    if (String(v.inventory_policy || '').toLowerCase() === 'continue') return false;
    if (!variantIsPurchasable(v)) return true;
    if (v.inventory_management === 'shopify' && v.inventory_policy === 'deny') {
      var q = parseInt(v.inventory_quantity, 10);
      if (isNaN(q) || q <= 0) return true;
    }
    return false;
  }

  function validateConfiguratorCartInventory(items, catPanel, catPost, catExtras) {
    var problems = [];
    if (!items || !items.length) return problems;
    items.forEach(function (it) {
      var buckets = [catPanel, catPost, catExtras];
      var labels = [DATA.CART_HANDLES.panel, DATA.CART_HANDLES.post, DATA.CART_HANDLES.extras];
      var bi;
      var maxQ = null;
      var label = 'Produkt';
      for (bi = 0; bi < buckets.length; bi++) {
        if (!buckets[bi]) continue;
        maxQ = variantCatalogMaxPurchasable(buckets[bi], it.id);
        if (maxQ !== null) {
          label = labels[bi];
          break;
        }
      }
      if (maxQ === null) {
        for (bi = 0; bi < buckets.length; bi++) {
          if (buckets[bi] && variantCatalogSoldOut(buckets[bi], it.id)) {
            label = labels[bi];
            maxQ = 0;
            break;
          }
        }
      }
      if (maxQ === null) return;
      var want = parseInt(it.quantity, 10) || 0;
      if (maxQ === 0) {
        var extra =
          label === DATA.CART_HANDLES.extras
            ? ' Admin → Konfigurator Zubehör → Profi-Montage pro Panel: unter „Mağaza konumu“ Bestand z. B. 999 eintragen oder „Sell when out of stock“ speichern, dann Seite neu laden.'
            : '';
        problems.push('„' + label + '“: für den Online-Shop nicht kaufbar (verfügbar 0).' + extra);
      } else if (want > maxQ) {
        problems.push(
          '„' + label + '“: nur ' + maxQ + ' Stück online verfügbar, Konfiguration benötigt ' + want + '.'
        );
      }
    });
    return problems;
  }

  /** Summe aller Mengen pro /cart/add.js — darunter bleibt der Shop oft unter „nur 50 Artikel“. */
  var CART_ADD_MAX_SUM_QUANTITY = 45;

  function buildExpectedVariantQtyMap(lineItems) {
    var map = {};
    lineItems.forEach(function (it) {
      var k = String(it.id);
      map[k] = (map[k] || 0) + (parseInt(it.quantity, 10) || 0);
    });
    return map;
  }

  function packCartAddsByTotalQty(lineItems, maxSumQty) {
    var maxSum = maxSumQty || CART_ADD_MAX_SUM_QUANTITY;
    var batches = [];
    var cur = [];
    var sum = 0;
    function flush() {
      if (cur.length) {
        batches.push(cur);
        cur = [];
        sum = 0;
      }
    }
    lineItems.forEach(function (it) {
      var rem = parseInt(it.quantity, 10) || 0;
      if (rem < 1) return;
      var props = it.properties || {};
      while (rem > 0) {
        if (sum >= maxSum) flush();
        var space = maxSum - sum;
        var take = Math.min(rem, space);
        cur.push({ id: it.id, quantity: take, properties: props });
        sum += take;
        rem -= take;
      }
    });
    flush();
    return batches.length ? batches : [[]];
  }

  function isLocalThemeDevHost() {
    var h = window.location.hostname;
    return h === '127.0.0.1' || h === 'localhost';
  }

  function cartUrlForRedirect(b) {
    if (!b) return '/cart';
    if (isLocalThemeDevHost() && b.shopRoot) {
      var url = String(b.shopRoot).replace(/\/$/, '') + '/cart';
      if (b.themeId) {
        url += (url.indexOf('?') >= 0 ? '&' : '?') + 'preview_theme_id=' + b.themeId;
      }
      return url;
    }
    return b.cartUrl || '/cart';
  }

  function cartApiHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };
  }

  function cartAddViaStoreForm(batch) {
    if (!boot.shopRoot) throw new Error('Warenkorb: Shop-URL fehlt (shopRoot).');
    var base = String(boot.shopRoot).replace(/\/$/, '');
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = base + '/cart/add';
    form.target = '_top';
    form.style.display = 'none';
    var i;
    for (i = 0; i < batch.length; i++) {
      var it = batch[i];
      var idInp = document.createElement('input');
      idInp.type = 'hidden';
      idInp.name = 'items[' + i + '][id]';
      idInp.value = String(it.id);
      form.appendChild(idInp);
      var qInp = document.createElement('input');
      qInp.type = 'hidden';
      qInp.name = 'items[' + i + '][quantity]';
      qInp.value = String(it.quantity);
      form.appendChild(qInp);
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          var pInp = document.createElement('input');
          pInp.type = 'hidden';
          pInp.name = 'items[' + i + '][properties][' + k + ']';
          pInp.value = String(it.properties[k]);
          form.appendChild(pInp);
        });
      }
    }
    var rtInp = document.createElement('input');
    rtInp.type = 'hidden';
    rtInp.name = 'return_to';
    rtInp.value = cartUrlForRedirect(boot);
    form.appendChild(rtInp);
    document.body.appendChild(form);
    form.submit();
    return { formRedirect: true };
  }

  function cartMode() {
    var m = boot && boot.cartMode ? String(boot.cartMode).toLowerCase() : 'auto';
    return m === 'sku' || m === 'single' || m === 'auto' ? m : 'auto';
  }

  function singleLineVariantId() {
    if (boot && boot.configuratorVariantId) return boot.configuratorVariantId;
    if (boot && boot.fallbackCartVariantId) return boot.fallbackCartVariantId;
    return null;
  }

  function canUseSingleLineCart() {
    if (cartMode() === 'sku') return false;
    return !!singleLineVariantId();
  }

  function buildSingleLineCartProperties(totals, panelSku, postSku, color, mountData, gateData, postData, summaryProps, configNote) {
    var props = Object.assign({}, summaryProps);
    props['Konfigurator-Modus'] = 'Sammelposition';
    props['Panel_SKU'] = panelSku;
    props['Panel_Anzahl'] = String(totals.fields);
    props['Pfosten_SKU'] = postSku;
    props['Pfosten_Anzahl'] = String(totals.posts);
    props['Zaunlaenge_m'] = String(totals.lengthM);
    props['Drahtstaerke'] = state.wire;
    props['Farbe'] = color.ral + ' ' + color.name;
    props['Pfosten_Typ'] = postData.label;
    if (DATA.SHOW_GATE_SECTION && gateData && gateData.id !== 'none') props['Tor'] = gateData.label;
    props['Gesamtpreis_Konfigurator'] = formatPrice(totals.total);
    if (configNote) props['Konfigurator-Details'] = configNote;
    return props;
  }

  function addConfiguratorSingleLineCart(ctx) {
    var vid = singleLineVariantId();
    if (!vid) {
      return Promise.reject(
        new Error(
          'Keine Sammel-Variante. Theme Editor → Zaun Konfigurator → „Warenkorb-Produkt“ wählen (mit „Weiter verkaufen wenn ausverkauft“).'
        )
      );
    }
    var item = {
      id: vid,
      quantity: 1,
      properties: buildSingleLineCartProperties(
        ctx.totals,
        ctx.panelSku,
        ctx.postSku,
        ctx.color,
        ctx.mountData,
        ctx.gateData,
        ctx.postData,
        ctx.summaryProps,
        ctx.configNote
      ),
    };
    return cartAddBatchesSequential([[item]]);
  }

  function runSingleLineCartAdd(ctx) {
    var btn = ctx.btn;
    var msgEl = ctx.msgEl;
    cartBusy = true;
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Wird hinzugefügt…';
    }
    return addConfiguratorSingleLineCart(ctx)
      .then(function () {
        cartBusy = false;
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = 'In den Warenkorb ' + ICON_ARROW;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (msgEl) {
          msgEl.className = 'hk-cart-msg is-success';
          msgEl.textContent =
            'Konfiguration im Warenkorb (Sammelposition — Panel/Pfosten-Mengen in den Artikeleigenschaften).';
        }
        if (boot.redirectAfterAdd) {
          setTimeout(function () {
            window.location.href = cartUrlForRedirect(boot);
          }, 800);
        }
      })
      .catch(function (err) {
        cartBusy = false;
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = 'In den Warenkorb ' + ICON_ARROW;
        }
        if (msgEl) {
          msgEl.className = 'hk-cart-msg is-error';
          msgEl.textContent = err.message || 'Warenkorb fehlgeschlagen.';
        }
      });
  }

  function fetchVariantStorefrontRow(variantId) {
    if (!variantId) return Promise.resolve(null);
    var P = typeof window !== 'undefined' && window.ZaunIdealKonfigPricing;
    if (P && P.fetchVariantDetailById) {
      return P.fetchVariantDetailById(variantId).catch(function () {
        return null;
      });
    }
    return fetch('/variants/' + encodeURIComponent(variantId) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  function assertLineItemsSellable(lineItems) {
    if (!lineItems || !lineItems.length) return Promise.resolve([]);
    return Promise.all(
      lineItems.map(function (it) {
        return fetchVariantStorefrontRow(it.id).then(function (v) {
          return { item: it, variant: v };
        });
      })
    ).then(function (rows) {
      var blocked = [];
      rows.forEach(function (row) {
        if (!row.variant) return;
        if (row.variant.available !== false) return;
        blocked.push(
          (row.variant.name || row.variant.title || 'Variante ' + row.item.id) +
            ' (ID ' +
            row.item.id +
            ') ist im Shop als ausverkauft gemeldet.'
        );
      });
      return blocked;
    });
  }

  function postCartAddJs(batch, retryCount) {
    var retries = retryCount == null ? 2 : retryCount;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: cartApiHeaders(),
      body: JSON.stringify({ items: batch }),
    }).then(function (r) {
      return r.text().then(function (text) {
        if (!r.ok && (r.status === 502 || r.status === 503 || r.status === 0) && retries > 0) {
          return new Promise(function (resolve) {
            setTimeout(resolve, 700);
          }).then(function () {
            return postCartAddJs(batch, retries - 1);
          });
        }
        var body = (text || '').trim();
        if (
          isLocalThemeDevHost() &&
          boot &&
          boot.shopRoot &&
          (r.status === 403 || body.charAt(0) === '<')
        ) {
          return cartAddViaStoreForm(batch);
        }
        return parseCartAddResponse(r, text);
      });
    });
  }

  function cartAddBatchesSequential(batches) {
    return batches.reduce(function (chain, batch) {
      if (!batch || !batch.length) return chain;
      return chain.then(function (prev) {
        if (prev && prev.formRedirect) return prev;
        return postCartAddJs(batch).catch(function (err) {
          if (isLocalThemeDevHost() && boot && boot.shopRoot) {
            return cartAddViaStoreForm(batch);
          }
          throw err;
        });
      });
    }, Promise.resolve());
  }

  function verifyCartVariantTotals(expectedMap) {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var short = [];
        Object.keys(expectedMap).forEach(function (vid) {
          var want = expectedMap[vid];
          var got = 0;
          (cart.items || []).forEach(function (line) {
            if (String(line.variant_id) === vid) got += line.quantity;
          });
          if (got < want) short.push({ vid: vid, want: want, got: got });
        });
        return short;
      });
  }

  function handleCart() {
    if (cartBusy) return;
    var msgEl = root.querySelector('.hk-cart-msg');
    if (msgEl) { msgEl.className = 'hk-cart-msg'; }

    var totals   = computeTotals();
    var color    = find(DATA.COLORS,  function (c) { return c.ral === state.color; }) || DATA.COLORS[0];
    var postData = find(DATA.POSTS,   function (p) { return p.id === state.post; })   || DATA.POSTS[0];
    var mountData= find(DATA.MOUNTS,  function (m) { return m.id === state.mount; })  || DATA.MOUNTS[0];
    var gateData = find(DATA.GATES,   function (g) { return g.id === state.gate; })   || DATA.GATES[0];

    var panelSku = 'panel-' + (state.height + 230);
    var postSku  = DATA.POST_SKUS[state.height] || 'post-h240';

    var useZubehoerCart = DATA.CART_ADD_ZUBEHOER === true;
    var configNote = buildCartConfigNote(totals, mountData);
    var summaryProps = {
      'Konfiguration': state.height + 'mm · ' + state.length + 'm · ' + color.name + ' · ' + state.wire,
      'Montageart':    mountData.label,
      'Mit_Montage':   state.mitMontage ? 'Ja' : 'Nein',
    };
    if (configNote) summaryProps['Konfigurator-Details'] = configNote;

    var singleLineCtx = {
      btn: root.querySelector('.hk-btn-primary'),
      msgEl: msgEl,
      totals: totals,
      panelSku: panelSku,
      postSku: postSku,
      color: color,
      mountData: mountData,
      gateData: gateData,
      postData: postData,
      summaryProps: summaryProps,
      configNote: configNote,
    };

    if (cartMode() === 'single') {
      if (!canUseSingleLineCart()) {
        if (msgEl) {
          msgEl.className = 'hk-cart-msg is-error';
          msgEl.textContent =
            boot.msgNoVariant ||
            'Bitte im Theme Editor „Warenkorb-Produkt“ wählen (Produkt mit „Weiter verkaufen wenn ausverkauft“).';
        }
        return;
      }
      runSingleLineCartAdd(singleLineCtx);
      return;
    }

    var abdeckExtra = find(DATA.EXTRAS, function (x) { return x.id === 'abdeck'; });
    var wantAbdeck = useZubehoerCart && !!(state.extras || {}).abdeck && abdeckExtra && abdeckExtra.cartSku;
    var abdeckSkuList =
      wantAbdeck && abdeckExtra
        ? abdeckExtra.cartSkus && abdeckExtra.cartSkus.length
          ? abdeckExtra.cartSkus.slice()
          : [abdeckExtra.cartSku]
        : [];

    var meterQty = Math.max(1, Math.round(Number(totals.lengthM) || state.length));

    var gateBundleLines =
      DATA.SHOW_GATE_SECTION && gateData.gateLines && gateData.gateLines.length ? gateData.gateLines : null;
    var gateSkuList = [];
    if (DATA.SHOW_GATE_SECTION && !gateBundleLines && gateData.id !== 'none') {
      if (gateData.gateSkus && gateData.gateSkus.length) gateSkuList = gateData.gateSkus.slice();
      else if (gateData.sku) gateSkuList = [gateData.sku];
    }

    var postSurSkus = [];
    if (postData.surcharge > 0 && postData.surchargeCartSku) {
      postSurSkus = postData.surchargeCartSkus && postData.surchargeCartSkus.length
        ? postData.surchargeCartSkus.slice()
        : [postData.surchargeCartSku];
    }
    var mountLineSkus = [];
    if (mountData.surcharge > 0 && mountData.mountCartSku) {
      mountLineSkus = mountData.mountCartSkus && mountData.mountCartSkus.length
        ? mountData.mountCartSkus.slice()
        : [mountData.mountCartSku];
    }

    var exLines = [];
    if (useZubehoerCart) {
      for (var exId in state.extras || {}) {
        if (!state.extras[exId] || exId === 'abdeck') continue;
        var ex = find(DATA.EXTRAS, function (x) { return x.id === exId; });
        if (!ex || !ex.cartSku) continue;
        if (ex.requiresGate && (!DATA.SHOW_GATE_SECTION || !gateData || gateData.id === 'none')) continue;
        var exQty = ex.perPost ? totals.posts : (ex.perMeter ? meterQty : 1);
        if (exQty < 1) continue;
        exLines.push({
          handle: ex.cartHandle || DATA.CART_HANDLES.extras,
          skus: ex.cartSkus && ex.cartSkus.length ? ex.cartSkus.slice() : [ex.cartSku],
          qty: exQty,
          label: ex.label,
          titleHints: ex.matchTitleHints || null,
        });
      }
    }

    var catPanel = boot.shopifyCatalog && boot.shopifyCatalog.panel;
    var catPost = boot.shopifyCatalog && boot.shopifyCatalog.post;
    var catGate = boot.shopifyCatalog && boot.shopifyCatalog.gate;
    var catExtras = boot.shopifyCatalog && boot.shopifyCatalog.extras;
    var panelSkuList = [panelSku];
    var postSkuList = [postSku];

    var lookups = [
      resolveFromShopifyCatalogThenFetch(DATA.CART_HANDLES.panel, panelSkuList, catPanel, null),
      resolveFromShopifyCatalogThenFetch(DATA.CART_HANDLES.post, postSkuList, catPost, null),
    ];
    if (useZubehoerCart) {
      if (postSurSkus.length) {
        lookups.push(
          resolveFromShopifyCatalogThenFetch(DATA.CART_HANDLES.extras, postSurSkus, catExtras, postData.matchTitleHints || null)
        );
      } else {
        lookups.push(Promise.resolve(null));
      }
      if (mountLineSkus.length) {
        lookups.push(
          resolveFromShopifyCatalogThenFetch(DATA.CART_HANDLES.extras, mountLineSkus, catExtras, mountData.matchTitleHints || null)
        );
      } else {
        lookups.push(Promise.resolve(null));
      }
    }
    if (DATA.SHOW_GATE_SECTION) {
      if (gateBundleLines) {
        for (var gbi = 0; gbi < gateBundleLines.length; gbi++) {
          lookups.push(
            resolveFromShopifyCatalogThenFetch(
              DATA.CART_HANDLES.gate,
              gateBundleLines[gbi].gateSkus || [],
              catGate,
              gateBundleLines[gbi].titleHints || null
            )
          );
        }
      } else {
        lookups.push(
          gateSkuList.length
            ? resolveFromShopifyCatalogThenFetch(DATA.CART_HANDLES.gate, gateSkuList, catGate, gateData.titleHints || null)
            : Promise.resolve(null)
        );
      }
    }
    var profMontageLookupIdx = -1;
    if (state.mitMontage) {
      profMontageLookupIdx = lookups.length;
      lookups.push(resolveProfMontageVariantId());
    }
    if (useZubehoerCart) {
      for (var eli = 0; eli < exLines.length; eli++) {
        lookups.push(
          resolveFromShopifyCatalogThenFetch(
            exLines[eli].handle,
            exLines[eli].skus,
            catExtras,
            exLines[eli].titleHints || null
          )
        );
      }
      if (wantAbdeck && abdeckSkuList.length) {
        lookups.push(
          resolveFromShopifyCatalogThenFetch(
            abdeckExtra.cartHandle || DATA.CART_HANDLES.extras,
            abdeckSkuList,
            catExtras,
            abdeckExtra.matchTitleHints || null
          )
        );
      }
    }

    var btn = root.querySelector('.hk-btn-primary');
    cartBusy = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }

    Promise.all(lookups)
      .then(function (ids) {
        var ix = 0;
        var panelId = ids[ix++];
        var postId = ids[ix++];
        var postSurId = null;
        var mountLId = null;
        if (useZubehoerCart) {
          postSurId = ids[ix++];
          mountLId = ids[ix++];
        }
        var gateIds = [];
        if (DATA.SHOW_GATE_SECTION) {
          if (gateBundleLines) {
            for (var gix = 0; gix < gateBundleLines.length; gix++) gateIds.push(ids[ix++]);
          } else {
            gateIds.push(ids[ix++]);
          }
        }
        var extraIds = [];
        for (var j = 0; j < exLines.length; j++) extraIds.push(ids[ix++]);
        var capId = wantAbdeck ? ids[ix++] : null;
        var profMontageId = profMontageLookupIdx >= 0 ? ids[profMontageLookupIdx] : null;

        if (!panelId || !postId) {
          if (canUseSingleLineCart()) {
            runSingleLineCartAdd(singleLineCtx);
            return;
          }
          cartBusy = false;
          if (btn) { btn.disabled = false; btn.innerHTML = 'In den Warenkorb ' + ICON_ARROW; }
          var panelSoldOut = catPanel && isCatalogSkuSoldOut(catPanel, panelSkuList, null);
          var postSoldOut = catPost && isCatalogSkuSoldOut(catPost, postSkuList, null);
          if (msgEl) {
            msgEl.className = 'hk-cart-msg is-error';
            if (postSoldOut) {
              msgEl.textContent =
                'Pfosten für ' +
                state.height +
                ' mm (SKU „' +
                postSku +
                '“) ist in Shopify ausverkauft. Bitte im Admin unter Produkt „' +
                DATA.CART_HANDLES.post +
                '“ Lagerbestand erhöhen oder „Weiter verkaufen wenn ausverkauft“ aktivieren.';
            } else if (panelSoldOut) {
              msgEl.textContent =
                'Panel (SKU „' +
                panelSku +
                '“) ist in Shopify ausverkauft. Bitte im Admin unter Produkt „' +
                DATA.CART_HANDLES.panel +
                '“ Lagerbestand prüfen.';
            } else {
              msgEl.textContent =
                'Warenkorb-Variante fehlt. Bitte Panel- und Pfosten-SKU im Shopify-Admin prüfen.';
            }
          }
          showNoVariantPreview({
            'Panel SKU':
              panelSku +
              (panelId ? ' ✓' : panelSoldOut ? ' ✗ AUSVERKAUFT (Admin: ' + DATA.CART_HANDLES.panel + ')' : ' ✗ nicht gefunden'),
            'Pfosten SKU':
              postSku +
              (postId ? ' ✓' : postSoldOut ? ' ✗ AUSVERKAUFT (Admin: ' + DATA.CART_HANDLES.post + ')' : ' ✗ nicht gefunden'),
            'Felder':     totals.fields + ' × 2,5 m',
            'Pfosten':    totals.posts + ' Stk',
            'Drahtstärke':state.wire,
            'Farbe':      color.ral + ' ' + color.name,
            'Montage':    mountData.label,
            'Gesamtpreis':formatPrice(totals.total),
          }, totals, { panelSoldOut: panelSoldOut, postSoldOut: postSoldOut });
          return;
        }

        var warnParts = [];
        if (state.mitMontage && !profMontageId) {
          cartBusy = false;
          if (btn) { btn.disabled = false; btn.innerHTML = 'In den Warenkorb ' + ICON_ARROW; }
          if (msgEl) {
            msgEl.className = 'hk-cart-msg is-error';
            msgEl.textContent =
              'Profi-Montage fehlt im Shop: Unter Produkt „' +
              DATA.CART_HANDLES.extras +
              '“ eine Variante mit SKU „' +
              montageCartSkus().join('“, „') +
              '“ anlegen (z. B. 100 €/Panel, „Weiter verkaufen wenn ausverkauft“), dann erneut versuchen.';
          }
          return;
        }
        if (DATA.SHOW_GATE_SECTION && gateBundleLines) {
          for (var gw = 0; gw < gateBundleLines.length; gw++) {
            if (!gateIds[gw] && (gateBundleLines[gw].gateSkus || []).length) {
              warnParts.push(
                'Tor („' +
                  gateBundleLines[gw].typ +
                  '“): keine Variante in „' +
                  DATA.CART_HANDLES.gate +
                  '“ (SKUs: ' +
                  (gateBundleLines[gw].gateSkus || []).join(', ') +
                  ').'
              );
            }
          }
        } else if (DATA.SHOW_GATE_SECTION && gateSkuList.length && !gateIds[0]) {
          warnParts.push(
            'Tor: keine Variante in „' + DATA.CART_HANDLES.gate + '“ (SKUs: ' + gateSkuList.join(', ') + ').'
          );
        }
        if (useZubehoerCart && postSurSkus.length && !postSurId) {
          warnParts.push(
            'Pfosten-Aufpreis: keine Variante in „' +
              DATA.CART_HANDLES.extras +
              '“ (SKUs: ' +
              postSurSkus.join(', ') +
              ') — Warenkorb kann unter dem Konfigurator-Preis liegen.'
          );
        }
        if (useZubehoerCart && mountLineSkus.length && !mountLId) {
          warnParts.push(
            'Montage-Aufpreis: keine Variante in „' + DATA.CART_HANDLES.extras + '“ (SKUs: ' + mountLineSkus.join(', ') + ').'
          );
        }
        if (useZubehoerCart) {
        for (var wj = 0; wj < exLines.length; wj++) {
          if (extraIds[wj]) continue;
          if (isCatalogSkuSoldOut(catExtras, exLines[wj].skus, exLines[wj].titleHints)) {
            warnParts.push(exLines[wj].label + ': ausverkauft — nicht in den Warenkorb gelegt.');
          } else {
            warnParts.push(exLines[wj].label + ': keine Variante (SKUs: ' + exLines[wj].skus.join(', ') + ').');
          }
        }
        }
        if (totals.mountCost < 0 && useZubehoerCart) {
          warnParts.push(
            'Montage-Rabatt ' +
              formatPrice(totals.mountCost) +
              ' ist im Gesamtpreis, in Shopify aber nicht als negative Zeile abbildbar.'
          );
        }

        var items = [];

        items.push({
          id: panelId,
          quantity: totals.fields,
          properties: Object.assign(
            { 'Typ': 'Doppelstabmatte ' + state.height + 'mm · ' + color.name + ' · ' + state.wire },
            summaryProps
          ),
        });

        items.push({
          id: postId,
          quantity: totals.posts,
          properties: Object.assign({ 'Typ': 'Pfosten ' + postData.label }, summaryProps),
        });

        if (useZubehoerCart && postSurId) {
          items.push({
            id: postSurId,
            quantity: totals.posts,
            properties: Object.assign({ 'Typ': 'Pfosten-Aufpreis · ' + postData.label }, summaryProps),
          });
        }

        if (useZubehoerCart && mountLId) {
          items.push({
            id: mountLId,
            quantity: meterQty,
            properties: Object.assign({ 'Typ': 'Montage-Aufpreis · ' + mountData.label }, summaryProps),
          });
        }

        if (DATA.SHOW_GATE_SECTION) {
          if (gateBundleLines) {
            for (var gq = 0; gq < gateBundleLines.length; gq++) {
              if (!gateIds[gq]) continue;
              items.push({
                id: gateIds[gq],
                quantity: gateBundleLines[gq].qty || 1,
                properties: Object.assign({ 'Typ': gateBundleLines[gq].typ }, summaryProps),
              });
            }
          } else if (gateIds[0]) {
            items.push({
              id: gateIds[0],
              quantity: 1,
              properties: Object.assign({ 'Typ': gateData.label }, summaryProps),
            });
          }
        }

        if (state.mitMontage && profMontageId) {
          items.push({
            id: profMontageId,
            quantity: totals.fields,
            properties: Object.assign({ 'Typ': 'Profi-Montage · Doppelstab' }, summaryProps),
          });
        }

        if (useZubehoerCart) {
        for (var ek = 0; ek < exLines.length; ek++) {
          if (!extraIds[ek]) continue;
          items.push({
            id: extraIds[ek],
            quantity: exLines[ek].qty,
            properties: Object.assign({ 'Typ': exLines[ek].label }, summaryProps),
          });
        }
        }

        var capWarning = '';
        if (useZubehoerCart && wantAbdeck) {
          if (capId) {
            items.push({
              id: capId,
              quantity: totals.posts,
              properties: Object.assign({ 'Typ': abdeckExtra.label }, summaryProps),
            });
          } else {
            capWarning =
              ' Pfostenabdeckkappen: keine Variante (Produkt „' +
              (abdeckExtra.cartHandle || DATA.CART_HANDLES.extras) +
              '“, SKUs: ' +
              abdeckSkuList.join(', ') +
              ') — nur im Gesamtpreis, nicht als eigene Position.';
          }
        }

        var softWarnings = warnParts.length ? ' ' + warnParts.join(' ') : '';

        var invProblems = validateConfiguratorCartInventory(items, catPanel, catPost, catExtras);
        if (invProblems.length) {
          if (canUseSingleLineCart()) {
            runSingleLineCartAdd(singleLineCtx);
            return;
          }
          cartBusy = false;
          if (btn) { btn.disabled = false; btn.innerHTML = 'In den Warenkorb ' + ICON_ARROW; }
          if (msgEl) {
            msgEl.className = 'hk-cart-msg is-error';
            msgEl.textContent =
              invProblems.join(' ') +
              ' Shopify Admin → Einstellungen → Standorte: „Mağaza konumu“ (oder Hauptlager) für Online-Bestellungen aktivieren, oder bei „' +
              DATA.CART_HANDLES.post +
              '“ / „' +
              DATA.CART_HANDLES.panel +
              '“ „Weiter verkaufen wenn ausverkauft“ einschalten.';
          }
          return;
        }

        var expectedQtyMap = buildExpectedVariantQtyMap(items);
        var batches = packCartAddsByTotalQty(items, CART_ADD_MAX_SUM_QUANTITY);

        return assertLineItemsSellable(items)
          .then(function (sellableBlocks) {
            if (sellableBlocks.length) {
              cartBusy = false;
              if (btn) { btn.disabled = false; btn.innerHTML = 'In den Warenkorb ' + ICON_ARROW; }
              if (msgEl) {
                msgEl.className = 'hk-cart-msg is-error';
                msgEl.textContent =
                  sellableBlocks.join(' ') +
                  ' Admin: Konfigurator Zubehör → Profi-Montage pro Panel → Mağaza konumu Bestand speichern, Konfigurator-Seite neu laden (Cmd+Shift+R).';
              }
              return { blocked: true };
            }
            return cartAddBatchesSequential(batches).then(function (addResult) {
              if (addResult && addResult.formRedirect) {
                return { formRedirect: true };
              }
              return verifyCartVariantTotals(expectedQtyMap).then(function (shortLines) {
                return { formRedirect: false, shortLines: shortLines };
              });
            });
          })
          .then(function (result) {
            if (!result || result.blocked) return;
            if (result.formRedirect) {
              if (msgEl) {
                msgEl.className = 'hk-cart-msg is-success';
                msgEl.textContent = 'Weiterleitung zum Warenkorb …';
              }
              return;
            }
            var shortLines = result.shortLines;
            cartBusy = false;
            if (btn) { btn.disabled = false; btn.innerHTML = 'In den Warenkorb ' + ICON_ARROW; }
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            if (shortLines && shortLines.length) {
              if (msgEl) {
                msgEl.className = 'hk-cart-msg is-error';
                var bits = shortLines.map(function (s) {
                  return 'Variante ' + s.vid + ': erwartet ' + s.want + ', im Warenkorb ' + s.got + '.';
                });
                msgEl.textContent =
                  'Nicht alle Stückzahlen wurden übernommen (Lager / Bestellmaximum). ' +
                  bits.join(' ') +
                  ' Bitte Mengen im Warenkorb prüfen oder im Shopify-Admin Bestand anpassen.';
              }
              return;
            }

            if (msgEl) {
              msgEl.className = 'hk-cart-msg is-success';
              var parts = [totals.fields + ' Felder', totals.posts + ' Pfosten'];
              if (wantAbdeck && capId) parts.push(totals.posts + ' Abdeckkappen');
              var baseMsg = boot.redirectAfterAdd
                ? parts.join(', ') + ' hinzugefügt — Weiterleitung …'
                : parts.join(', ') + ' zum Warenkorb hinzugefügt.';
              msgEl.textContent = baseMsg + capWarning + softWarnings;
            }
            if (boot.redirectAfterAdd) {
              setTimeout(function () { window.location.href = cartUrlForRedirect(boot); }, 800);
            }
          });
      })
      .catch(function (err) {
        var errMsg = err.message || 'Ein Fehler ist aufgetreten.';
        if (
          canUseSingleLineCart() &&
          cartMode() !== 'sku' &&
          /ausverkauft|sold out|nicht verfügbar|502|503|Bad Gateway/i.test(errMsg)
        ) {
          runSingleLineCartAdd(singleLineCtx);
          return;
        }
        cartBusy = false;
        if (btn) { btn.disabled = false; btn.innerHTML = 'In den Warenkorb ' + ICON_ARROW; }
        if (msgEl) {
          msgEl.className = 'hk-cart-msg is-error';
          if (/maximale Menge|Maximum quantity|already in your cart/i.test(errMsg)) {
            errMsg += ' — Prüfen Sie im Warenkorb die Mengen der Konfigurator-Varianten und im Shopify-Admin Lagerbestand / Bestellmaximum.';
          }
          if (/ausverkauft|sold out|nicht verfügbar/i.test(errMsg)) {
            errMsg +=
              ' Tipp: Theme Editor → „Warenkorb-Modus: Auto“ und „Warenkorb-Produkt“ wählen, oder Panel/Pfosten „Weiter verkaufen wenn ausverkauft“.';
          }
          if (/502|503|Bad Gateway/i.test(errMsg)) {
            errMsg +=
              ' Theme-Dev-Proxy fehlgeschlagen — Seite neu laden oder Vorschau über myshopify.com testen.';
          }
          msgEl.textContent = errMsg;
        }
      });
  }

  function handleSave() {
    saveState();
    var btn = root.querySelector('.hk-btn-ghost');
    if (btn) {
      var orig = btn.innerHTML;
      btn.textContent = 'Gespeichert ✓';
      setTimeout(function () { btn.innerHTML = orig; }, 1500);
    }
    renderInfoBanner();
  }

  function scheduleScrollOpenSectionIntoView() {
    if (!root || root.classList.contains('hk-embedded')) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var openSec = openSection ? root.querySelector('.hk-section.is-open[data-section="' + openSection + '"]') : null;
        if (openSec && typeof openSec.scrollIntoView === 'function') {
          openSec.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    });
  }

  /* ── Init ────────────────────────────────────────────────── */
  function montageCartSkus() {
    if (boot.montageCartSkus && boot.montageCartSkus.length) return boot.montageCartSkus;
    return DATA.MONTAGE_CART_SKUS;
  }

  function fetchVariantIdBySkuCatalog(skuList) {
    var P = typeof window !== 'undefined' && window.ZaunIdealKonfigPricing;
    if (!P) return Promise.resolve(null);
    var targets = [];
    var ti;
    for (ti = 0; ti < skuList.length; ti++) {
      var tn = P.normalizeCartSku(skuList[ti]);
      if (tn && targets.indexOf(tn) < 0) targets.push(tn);
    }
    if (!targets.length) return Promise.resolve(null);
    return fetch('/products.json?limit=250')
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.products) return null;
        var pi;
        var vi;
        var pr;
        var v;
        var norm;
        for (pi = 0; pi < data.products.length; pi++) {
          pr = data.products[pi];
          for (vi = 0; vi < (pr.variants || []).length; vi++) {
            v = pr.variants[vi];
            norm = P.normalizeCartSku(v.sku);
            if (norm && targets.indexOf(norm) >= 0) {
              P.primeSkuCache(pr.handle, [v.sku], v.id);
              return v.id;
            }
          }
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function buildCartConfigNote(totals, mountData) {
    var bits = ['Montageart: ' + mountData.label];
    if (state.mitMontage) {
      bits.push('Profi-Montage: Ja (' + totals.fields + ' × ' + DATA.MONTAGE_PANEL_EUR + ' €, im Konfigurator-Preis)');
    }
    if (totals.mountCost !== 0) {
      bits.push('Montage-Zuschlag: ' + formatPrice(totals.mountCost) + ' (im Konfigurator-Preis)');
    }
    return bits.join(' · ');
  }

  function isMontagePerMeterVariant(v) {
    if (!v) return false;
    var t = variantSearchBlob(v);
    if (t.indexOf('panel') !== -1) return false;
    return /pro[\s-]*meter|prometer|pro-m\b|pro-m$|pro meter/.test(t);
  }

  function variantUnitPriceEuro(v) {
    if (!v || v.price == null || v.price === '') return null;
    var P = typeof window !== 'undefined' && window.ZaunIdealKonfigPricing;
    if (P && P.normalizeVariantPriceToCents) {
      var cents = P.normalizeVariantPriceToCents(v.price);
      if (cents != null) return cents / 100;
    }
    var n = parseFloat(String(v.price).replace(',', '.'));
    if (isNaN(n)) return null;
    if (n >= 500 && n === Math.floor(n)) return n / 100;
    return n;
  }

  function matchesMontagePanelPrice(v) {
    var p = variantUnitPriceEuro(v);
    if (p == null) return true;
    var target = DATA.MONTAGE_PANEL_EUR;
    return p >= target * 0.5 && p <= target * 2.5;
  }

  function variantFieldsMatchSku(v, want) {
    if (!v || !want) return false;
    var parts = [v.sku, v.barcode, v.title, v.public_title, v.name, v.option1, v.option2, v.option3];
    var i;
    for (i = 0; i < parts.length; i++) {
      if (normalizeCartSku(parts[i]) === want) return true;
    }
    return false;
  }

  function findProfMontagePanelVariant(variants, skuList, requirePurchasable) {
    if (!variants || !variants.length || !skuList || !skuList.length) return null;
    var panelSkus = skuList.filter(function (s) {
      return normalizeCartSku(s).indexOf('panel') !== -1;
    });
    var tryLists = panelSkus.length ? [panelSkus, skuList] : [skuList];
    var li;
    var i;
    var j;
    var want;
    var v;
    function ok(vv) {
      return vv && (!requirePurchasable || variantIsPurchasable(vv));
    }
    for (li = 0; li < tryLists.length; li++) {
      for (i = 0; i < tryLists[li].length; i++) {
        want = normalizeCartSku(tryLists[li][i]);
        if (!want) continue;
        for (j = 0; j < variants.length; j++) {
          v = variants[j];
          if (!ok(v)) continue;
          if (variantFieldsMatchSku(v, want) && !isMontagePerMeterVariant(v) && matchesMontagePanelPrice(v)) {
            return v;
          }
        }
      }
      v = findCatalogVariant(variants, tryLists[li], null, requirePurchasable);
      if (v && !isMontagePerMeterVariant(v) && matchesMontagePanelPrice(v)) return v;
    }
    return null;
  }

  function resolveProfMontageVariantId() {
    var skus = montageCartSkus().filter(function (s) {
      return normalizeCartSku(s).indexOf('panel') !== -1;
    });
    if (!skus.length) skus = montageCartSkus();
    var manualId = lookupManualVariantMap(skus);
    if (manualId) return Promise.resolve(manualId);
    var handle = DATA.CART_HANDLES.extras;
    var variants = parseCatalogVariants(boot.shopifyCatalog && boot.shopifyCatalog.extras);
    if (variants.length) {
      var v = findProfMontagePanelVariant(variants, skus, true);
      if (!v) v = findProfMontagePanelVariant(variants, skus, false);
      if (v) {
        cacheResolvedSkus(handle, skus, v.id);
        return Promise.resolve(v.id);
      }
    }
    var i = 0;
    function next() {
      if (i >= skus.length) return Promise.resolve(null);
      var sku = skus[i++];
      return fetchVariantBySku(handle, sku).then(function (id) {
        if (!id) return next();
        cacheResolvedSkus(handle, skus, id);
        return id;
      });
    }
    return next();
  }

  function init() {
    boot = readBoot();
    applyBootCartHandles(boot);
    bootAssets = (boot && boot.assetUrls) || {};
    root = document.querySelector('.hk-konfigurator');
    if (!root) return;

    // set initial done sections (all except open)
    SECTION_IDS.forEach(function (id) {
      if (id !== openSection) doneSections[id] = true;
    });

    render();
    wireEvents();
    scheduleScrollOpenSectionIntoView();

    // cart button
    root.addEventListener('click', function (e) {
      if (e.target.closest('.hk-btn-primary')) handleCart();
      if (e.target.closest('.hk-btn-ghost'))   handleSave();
      if (e.target.closest('[data-action="reset"]')) resetState();
    });

    // save on section close
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveState();
    });
    window.addEventListener('beforeunload', saveState);
  }

  /* ── Helpers ─────────────────────────────────────────────── */
  function find(arr, fn) {
    for (var i = 0; i < arr.length; i++) {
      if (fn(arr[i])) return arr[i];
    }
    return null;
  }

  /* ── Embedded init (called from outside, e.g. inside another component) ── */
  function initEmbedded(container) {
    boot = readBoot();
    applyBootCartHandles(boot);
    bootAssets = (boot && boot.assetUrls) || {};
    // Build the full HTML structure inside the given container
    container.classList.add('hk-konfigurator', 'hk-embedded');
    container.innerHTML =
            '<div class="hk-emb-preview">' +
        '<div class="hk-fence-wrap"></div>' +
        '<div class="hk-dim-label">' +
          '<span class="lbl-vert">Höhe</span>' +
          '<span class="lbl-pill hk-dim-pill">1600 mm</span>' +
        '</div>' +
        '<div class="hk-info-card">' +
          '<span class="k">RAL</span><b class="v">6005</b>' +
          '<span class="k">FARBE</span><b class="v">grün</b>' +
          '<span class="k">DRAHT</span><b class="v">8/6/8</b>' +
        '</div>' +
        '<span class="hk-preview-pill" style="position:absolute;top:10px;left:50%;transform:translateX(-50%)">5 m · 1600 mm</span>' +
      '</div>' +
            '<div class="hk-emb-body">' +
        '<div class="hk-step-meta" style="padding:12px 16px 0">' +
          '<span class="eyebrow">Konfiguration · 7 Schritte</span>' +
          '<div class="hk-progress"></div>' +
        '</div>' +
        '<div class="hk-info-banner" style="display:none;margin:8px 16px 0">' +
          '<span class="hk-banner-text"></span>' +
          '<a data-action="reset">Zurücksetzen</a>' +
        '</div>' +
        '<div class="hk-config-sections" style="padding:8px 0 16px"></div>' +
      '</div>' +
            '<div class="hk-emb-cta">' +
        '<div class="hk-price-block">' +
          '<span class="hk-price-lbl">Gesamtpreis · inkl. 19 % MwSt.</span>' +
          '<span class="hk-price-val">—</span>' +
        '</div>' +
        '<div class="hk-cta-group">' +
          '<button class="hk-btn-ghost">' + ICON_SAVE + ' Speichern</button>' +
          '<button class="hk-btn-primary">In den Warenkorb ' + ICON_ARROW + '</button>' +
        '</div>' +
        '<div class="hk-cart-msg"></div>' +
        '<div class="hk-price-detail" aria-live="polite"></div>' +
      '</div>';

    root = container;

    SECTION_IDS.forEach(function (id) {
      if (id !== openSection) doneSections[id] = true;
    });

    render();
    wireEvents();

    // Floating preview: appears when the main preview scrolls out of view
    var floatDiv = document.createElement('div');
    floatDiv.id = 'hk-float-preview';
    floatDiv.innerHTML =
      '<div class="hk-float-fence"></div>' +
      '<div class="hk-float-info">' +
        '<span class="hk-float-height">—</span>' +
        '<small class="hk-float-length">— m · — Felder</small>' +
      '</div>';
    document.body.appendChild(floatDiv);

    var previewEl = container.querySelector('.hk-emb-preview');
    function updateEmbFloatVisibility() {
      if (!previewEl || !floatDiv) return;
      var r = previewEl.getBoundingClientRect();
      var vh = window.innerHeight || 0;
      var vw = window.innerWidth || 0;
      if (r.height < 4 || r.width < 4) return;
      var ih = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      var iw = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
      var frac = (ih * iw) / (r.height * r.width);
      var scrolledAway = r.bottom < 88 || r.top > vh - 32;
      var partlyHidden = frac < 0.92;
      var nearViewportTop = r.top < 96 && r.bottom > 200;
      var showFloat = scrolledAway || partlyHidden || nearViewportTop;
      floatDiv.classList.toggle('is-visible', showFloat);
      if (showFloat) {
        var reserve = (floatDiv.offsetHeight || 96) + 28;
        document.documentElement.style.setProperty('--hk-float-reserve', reserve + 'px');
        document.body.classList.add('hk-float-active');
      } else {
        document.documentElement.style.setProperty('--hk-float-reserve', '0px');
        document.body.classList.remove('hk-float-active');
      }
    }
    window.__hkSyncEmbFloat = updateEmbFloatVisibility;

    var floatScrollTimer = null;
    function scheduleEmbFloat() {
      if (floatScrollTimer) cancelAnimationFrame(floatScrollTimer);
      floatScrollTimer = requestAnimationFrame(function () {
        floatScrollTimer = null;
        updateEmbFloatVisibility();
      });
    }
    window.addEventListener('scroll', scheduleEmbFloat, true);
    window.addEventListener('resize', updateEmbFloatVisibility);

    if (previewEl && window.IntersectionObserver) {
      var floatIO = new IntersectionObserver(
        function () {
          updateEmbFloatVisibility();
        },
        {
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
          rootMargin: '0px 0px -48px 0px',
        }
      );
      floatIO.observe(previewEl);
    }
    requestAnimationFrame(updateEmbFloatVisibility);

    container.addEventListener('click', function (e) {
      if (e.target.closest('.hk-btn-primary')) handleCart();
      if (e.target.closest('.hk-btn-ghost'))   handleSave();
      if (e.target.closest('[data-action="reset"]')) resetState();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveState();
    });
    window.addEventListener('beforeunload', saveState);
  }
  window.initHKEmbedded = initEmbedded;

  // Returns full pricing breakdown for a given length, using current right-side state
  window.HKGetLength = function () {
    return state.length;
  };

  window.HKComputeForLength = function(lengthM) {
    var savedLength = state.length;
    state.length = Math.max(1, Math.round(lengthM));
    var totals = computeTotals();
    state.length = savedLength;

    var wire  = find(DATA.WIRES,  function (w) { return w.value === state.wire; })  || DATA.WIRES[0];
    var post  = find(DATA.POSTS,  function (p) { return p.id === state.post; })     || DATA.POSTS[0];
    var mount = find(DATA.MOUNTS, function (m) { return m.id === state.mount; })    || DATA.MOUNTS[0];
    var gate  = find(DATA.GATES,  function (g) { return g.id === state.gate; })     || DATA.GATES[0];
    var color = find(DATA.COLORS, function (c) { return c.ral === state.color; })   || DATA.COLORS[0];

    var extras = state.extras || {};
    var extraLines = [];
    for (var id in extras) {
      if (!extras[id]) continue;
      var ex = find(DATA.EXTRAS, function (x) { return x.id === id; });
      if (!ex) continue;
      var cost = ex.perPost ? ex.price * totals.posts : ex.perMeter ? ex.price * totals.lengthM : ex.price;
      var qty = ex.perPost ? totals.posts : ex.perMeter ? totals.lengthM + ' m' : '1';
      extraLines.push({ name: ex.label, qty: qty, unit: ex.perPost ? 'Stk.' : ex.perMeter ? '' : 'Stk.', price: cost });
    }

    return {
      lengthM: totals.lengthM,
      fields: totals.fields,
      posts: totals.posts,
      total: totals.total,
      weight: totals.weight,
      priceFormatted: formatPrice(totals.total),
      breakdown: (function () {
        var pp = totals.panelPrice.toFixed(2).replace('.', ',');
        var po = totals.postPrice.toFixed(2).replace('.', ',');
        var lines = [
          { name: 'Doppelstabmatte ' + state.height + ' mm', detail: color.name + ' · ' + state.wire + ' · ' + pp + ' €/Feld', qty: totals.fields, unit: 'Felder', price: totals.fenceCost },
          { name: post.label, detail: po + ' €/Stk.', qty: totals.posts, unit: 'Stk.', price: totals.postCost },
        ];
        if (totals.mountCost !== 0) {
          var mountDetail = mount.surcharge === 0 ? 'inkl.' : (mount.surcharge > 0 ? '+' + mount.surcharge + ' €/m' : mount.surcharge + ' €/m');
          lines.push({ name: mount.label, detail: mountDetail, qty: totals.lengthM, unit: 'm', price: totals.mountCost });
        }
        if (state.mitMontage && totals.profMontageCost > 0) {
          lines.push({
            name: 'Profi-Montage',
            detail: DATA.MONTAGE_PANEL_EUR.toFixed(2).replace('.', ',') + ' €/Panel',
            qty: totals.fields,
            unit: 'Felder',
            price: totals.profMontageCost,
          });
        }
        if (DATA.SHOW_GATE_SECTION && totals.gateCost !== 0) {
          lines.push({ name: gate.label, detail: '', qty: 1, unit: 'Stk.', price: totals.gateCost });
        }
        for (var xi = 0; xi < extraLines.length; xi++) {
          var exl = extraLines[xi];
          lines.push({ name: exl.name, detail: '', qty: exl.qty, unit: exl.unit, price: exl.price });
        }
        return lines.filter(function (l) { return l.price !== 0; });
      })(),
      state: {
        wire: state.wire,
        height: state.height,
        color: color.name,
        ral: state.color,
        post: post.label,
        mount: mount.label,
        gate: gate.label,
      }
    };
  };

  // Called from canvas/map drawing when perimeter changes
  window.HKSetLength = function(meters) {
    var rounded = Math.max(1, Math.round(meters));
    state.length = rounded;
    state.lengthFromCanvas = true;
    render();
  };

  // Called when canvas is cleared — re-enable manual length input
  window.HKClearCanvasLength = function() {
    state.lengthFromCanvas = false;
    render();
  };

  window.HKAddToCart = handleCart;

  /* ── Boot (standalone page mode) ────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
